/*
 * Accessibility repairs for markup the theme's own scripts build at runtime,
 * which therefore cannot be fixed in Liquid.
 *
 * Each block notes the WCAG success criterion it addresses.
 */
(function () {
  'use strict';

  var FOCUSABLE =
    'a[href], button, input, select, textarea, iframe, [tabindex]:not([tabindex="-1"])';

  /*
   * 4.1.2 Name, Role, Value - the carousels mark off-screen cells with
   * aria-hidden but leave the links inside them in the tab order, so keyboard
   * focus lands on content a screen reader is told does not exist. Pull those
   * controls out of the tab order and put them back when the cell is shown.
   * tabindex is used rather than `inert` so that a partly visible card can
   * still be clicked with the mouse.
   */
  function syncHiddenSubtrees(root) {
    syncMiniCartToolPanels(root || document);
    var hidden = root.querySelectorAll('[aria-hidden="true"]');
    for (var i = 0; i < hidden.length; i++) {
      var nodes = hidden[i].querySelectorAll(FOCUSABLE);
      for (var j = 0; j < nodes.length; j++) {
        var el = nodes[j];
        if (!el.hasAttribute('data-a11y-tabindex')) {
          el.setAttribute(
            'data-a11y-tabindex',
            el.hasAttribute('tabindex') ? el.getAttribute('tabindex') : ''
          );
        }
        el.setAttribute('tabindex', '-1');
      }
    }
    var parked = root.querySelectorAll('[data-a11y-tabindex]');
    for (var k = 0; k < parked.length; k++) {
      var node = parked[k];
      if (node.closest('[aria-hidden="true"]')) continue;
      var prev = node.getAttribute('data-a11y-tabindex');
      if (prev === '') node.removeAttribute('tabindex');
      else node.setAttribute('tabindex', prev);
      node.removeAttribute('data-a11y-tabindex');
    }
  }

  /*
   * Mini-cart Note/Shipping/Coupon/Gift panels stay in the DOM off-screen
   * (translateY + pointer-events:none). aria-hidden alone does not remove them
   * from Chrome's Tab order, so also set inert and force tabindex=-1 while
   * closed. Reveal only when .is--opend.
   */
  function syncMiniCartToolPanels(root) {
    var panels = (root || document).querySelectorAll('.t4s-mini_cart-tool__content');
    for (var i = 0; i < panels.length; i++) {
      var panel = panels[i];
      var open = panel.classList.contains('is--opend');
      if (open) {
        if (panel.getAttribute('aria-hidden') !== 'false') {
          panel.setAttribute('aria-hidden', 'false');
        }
        try {
          panel.inert = false;
        } catch (e) {
          /* older engines */
        }
        panel.removeAttribute('inert');
      } else {
        if (panel.getAttribute('aria-hidden') !== 'true') {
          panel.setAttribute('aria-hidden', 'true');
        }
        try {
          panel.inert = true;
        } catch (e2) {
          panel.setAttribute('inert', '');
        }
        var nodes = panel.querySelectorAll(
          'a[href], button, input, select, textarea, iframe, [tabindex]'
        );
        for (var j = 0; j < nodes.length; j++) {
          var el = nodes[j];
          if (!el.hasAttribute('data-a11y-tabindex')) {
            el.setAttribute(
              'data-a11y-tabindex',
              el.hasAttribute('tabindex') ? el.getAttribute('tabindex') : ''
            );
          }
          el.setAttribute('tabindex', '-1');
        }
      }
    }
  }

  /*
   * 4.1.2 - the price filter is a noUiSlider, whose drag handles get
   * role="slider" and value attributes but no accessible name.
   */
  function labelSliderHandles(root) {
    var pairs = [
      ['.noUi-handle-lower', 'Minimum price'],
      ['.noUi-handle-upper', 'Maximum price']
    ];
    for (var i = 0; i < pairs.length; i++) {
      var nodes = root.querySelectorAll(pairs[i][0] + ':not([aria-label])');
      for (var j = 0; j < nodes.length; j++) {
        nodes[j].setAttribute('aria-label', pairs[i][1]);
      }
    }
  }

  /*
   * 2.1.1 Keyboard - the product thumbnail strip scrolls horizontally but is
   * not reachable by keyboard, so its content is unavailable without a mouse.
   */
  function makeScrollersFocusable(root) {
    var nodes = root.querySelectorAll(
      '[data-thumb__scroller], .t4s-carousel__nav-scroller'
    );
    for (var i = 0; i < nodes.length; i++) {
      if (!nodes[i].hasAttribute('tabindex')) {
        nodes[i].setAttribute('tabindex', '0');
      }
      if (!nodes[i].getAttribute('role')) {
        nodes[i].setAttribute('role', 'group');
      }
      if (!nodes[i].hasAttribute('aria-label')) {
        nodes[i].setAttribute('aria-label', 'Product image thumbnails');
      }
    }
  }

  /*
   * 4.1.2 Name, Role, Value — Flickity leaves the main PDP gallery viewport
   * focusable (tabindex=0) with no role/name, so NVDA reads a long blob of
   * image + Previous/Next text. Name the group; keep keyboard access.
   */
  function labelProductGalleries(root) {
    var nodes = root.querySelectorAll(
      '[data-main-media], [data-main-media] .flickityt4s-viewport, .t4s-product__media-wrapper .flickityt4s-viewport'
    );
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var focusable =
        el.hasAttribute('tabindex') && el.getAttribute('tabindex') !== '-1';
      if (!focusable && !el.hasAttribute('data-main-media')) continue;
      if (!el.getAttribute('role')) el.setAttribute('role', 'group');
      if (!el.getAttribute('aria-label') && !el.getAttribute('aria-labelledby')) {
        el.setAttribute('aria-label', 'Product images');
      }
    }
  }

  /*
   * Mini-cart recommendations carousel: same pattern as PDP gallery — focusable
   * DIV without a name (NVDA final regression FAIL).
   */
  function labelMiniCartRecommendations(root) {
    var nodes = (root || document).querySelectorAll(
      '.t4s-minicart-recommendations_items, .t4s-minicart-recommendations_items .flickityt4s-viewport'
    );
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (!el.getAttribute('role')) el.setAttribute('role', 'group');
      if (!el.getAttribute('aria-label') && !el.getAttribute('aria-labelledby')) {
        var title = null;
      var wrap = el.closest('.t4s-minicart-recommendations');
      if (wrap) title = wrap.querySelector('.t4s-minicart-recommendations__title');
      if (title) {
        if (!title.id) title.id = 'a11y-minicart-recs-title';
        el.setAttribute('aria-labelledby', title.id);
      } else {
        el.setAttribute('aria-label', 'Recommended products');
      }
      }
    }
  }

  /*
   * Mobile product-card ATC: .t4s-text-pr is often display:none, leaving icon-only
   * links with no accessible name (search results link-name ×10).
   */
  function nameProductCardAtc(root) {
    var links = (root || document).querySelectorAll('a.t4s-pr-addtocart');
    for (var i = 0; i < links.length; i++) {
      var link = links[i];
      if (link.getAttribute('aria-label') || link.getAttribute('aria-labelledby')) continue;
      var textEl = link.querySelector('.t4s-text-pr');
      var visibleText = '';
      if (textEl) {
        try {
          var st = window.getComputedStyle(textEl);
          if (st.display !== 'none' && st.visibility !== 'hidden' && st.opacity !== '0') {
            visibleText = (textEl.textContent || '').replace(/\s+/g, ' ').trim();
          }
        } catch (e) {
          visibleText = (textEl.textContent || '').replace(/\s+/g, ' ').trim();
        }
      }
      if (visibleText) continue;

      var action = (textEl && (textEl.textContent || '').replace(/\s+/g, ' ').trim()) || 'Add to cart';
      var productName = '';
      var card =
        link.closest(
          '.t4s-product, .t4s-product-wrapper, [data-product-id], .t4s-pr-grid, .t4s-product-inner'
        ) || link.closest('article, li, .t4s-col-item');
      if (card) {
        var titleEl = card.querySelector(
          '.t4s-product-title, .t4s-product__title, a.t4s-product-title, .t4s-widget__pr-title, [data-product-title], .t4s-pr-name'
        );
        if (titleEl) productName = (titleEl.textContent || '').replace(/\s+/g, ' ').trim();
      }
      if (!productName && link.href) {
        try {
          var path = link.pathname || '';
          var m = path.match(/\/products\/([^/?#]+)/);
          if (m) productName = decodeURIComponent(m[1]).replace(/-/g, ' ');
        } catch (e2) {
          /* ignore */
        }
      }

      var label = productName
        ? /add to cart/i.test(action)
          ? 'Add ' + productName + ' to cart'
          : action + ': ' + productName
        : action;
      link.setAttribute('aria-label', label);

      var svg = link.querySelector('svg');
      if (svg && !svg.getAttribute('aria-hidden')) {
        svg.setAttribute('aria-hidden', 'true');
        svg.setAttribute('focusable', 'false');
      }
    }
  }

  /*
   * WAVE product-card remediation (2026-08-08).
   * Quick View, Wishlist, and direct Add to cart are scripted actions, so
   * expose them as buttons instead of links. Product-card overlays and the
   * duplicate image links in cart recommendations stay pointer-operable, but
   * are removed from the link sequence because an adjacent named product link
   * already exposes the same destination. The theme's Quick View handler still
   * reads `href`; provide it only for the duration of the click, from
   * data-product-url.
   */
  function normalizeRedundantProductLinks(root) {
    var scope = root || document;
    var actions = scope.querySelectorAll(
      'a[data-action-quickview][href], a[data-action-wishlist][href], a[data-action-atc][href], ' +
        'a.t4s-pr-addtocart[href], a.t4s-page_cart__edit[href], a.t4s-mini_cart__edit[href]'
    );
    for (var i = 0; i < actions.length; i++) {
      var action = actions[i];
      if (
        action.classList.contains('t4s-pr-addtocart') &&
        /^read\s+more$/i.test((action.textContent || '').replace(/\s+/g, ' ').trim())
      ) {
        continue;
      }
      action.setAttribute('data-product-url', action.href);
      action.removeAttribute('href');
      action.removeAttribute('rel');
      action.setAttribute('role', 'button');
      action.setAttribute('tabindex', '0');
    }

    var mirrors = scope.querySelectorAll(
      'a.t4s-full-width-link[href], a.t4s-mini_cart__img[href], a.t4s-page_cart__img[href], ' +
        '.t4s-minicart-recommendations__item--img > a[href], a.t4s-pr-addtocart[href]'
    );
    for (var j = 0; j < mirrors.length; j++) {
      var mirror = mirrors[j];
      if (
        mirror.classList.contains('t4s-pr-addtocart') &&
        !/^read\s+more$/i.test((mirror.textContent || '').replace(/\s+/g, ' ').trim())
      ) {
        continue;
      }
      mirror.setAttribute('data-product-url', mirror.href);
      mirror.removeAttribute('href');
      mirror.setAttribute('aria-hidden', 'true');
      mirror.setAttribute('tabindex', '-1');
      if (mirror.classList.contains('t4s-full-width-link')) {
        mirror.setAttribute('data-product-card-overlay', '');
      } else {
        mirror.setAttribute('data-product-link-mirror', '');
      }
    }
  }

  /*
   * WAVE mobile cart remediation (2026-08-08). Estimate shipping is a direct
   * subsection of the cart page H1, so expose it as H2. Replacing the dormant
   * heading node preserves all theme classes/children and avoids an ARIA/native
   * heading-level conflict.
   */
  function normalizeCartShippingHeading(root) {
    var scope = root || document;
    var headings = scope.querySelectorAll('.t4s-shipping_calculator h3.t4s-truncate');
    for (var i = 0; i < headings.length; i++) {
      var oldHeading = headings[i];
      var heading = document.createElement('h2');
      for (var j = 0; j < oldHeading.attributes.length; j++) {
        var attribute = oldHeading.attributes[j];
        heading.setAttribute(attribute.name, attribute.value);
      }
      while (oldHeading.firstChild) heading.appendChild(oldHeading.firstChild);
      oldHeading.parentNode.replaceChild(heading, oldHeading);
    }
  }

  /*
   * Search recommendation images are pointer-only mirrors of the adjacent named
   * product-title link. Their parent is already aria-hidden, but WAVE still compares
   * descendant alt text with the PDP image. Keep the decorative descendant explicit
   * for initial and dynamically injected search results.
   */
  function normalizeDecorativeSearchImages(root) {
    var scope = root || document;
    var images = scope.querySelectorAll('[data-search-product-image][aria-hidden="true"] img');
    for (var i = 0; i < images.length; i++) {
      images[i].setAttribute('alt', '');
      images[i].setAttribute('aria-hidden', 'true');
    }
  }

  var redundantProductLinksTimer = null;
  function scheduleRedundantProductLinks(delay) {
    if (redundantProductLinksTimer) return;
    redundantProductLinksTimer = setTimeout(function () {
      redundantProductLinksTimer = null;
      normalizeRedundantProductLinks(document);
      normalizeCartShippingHeading(document);
      normalizeDecorativeSearchImages(document);
      nameProductCardAtc(document);
      syncProductCardActionButtons(document);
      syncHiddenSubtrees(document);
    }, typeof delay === 'number' ? delay : 600);
  }

  function syncProductCardActionButtons(root) {
    var actions = (root || document).querySelectorAll(
      'a[role="button"][data-action-quickview], a[role="button"][data-action-wishlist]'
    );
    for (var i = 0; i < actions.length; i++) {
      var action = actions[i];
      if (!action.closest('[aria-hidden="true"], [inert]')) {
        action.setAttribute('tabindex', '0');
      }
      var card = action.closest('.t4s-product');
      var title = card && card.querySelector('.t4s-product-title');
      var productName = title
        ? (title.textContent || '').replace(/\s+/g, ' ').trim()
        : '';
      if (action.hasAttribute('data-action-quickview')) {
        action.setAttribute(
          'aria-label',
          productName ? 'Quick view: ' + productName : 'Quick view'
        );
      } else {
        var removing = action.classList.contains('is--added');
        action.setAttribute(
          'aria-label',
          productName
            ? (removing ? 'Remove ' + productName + ' from wishlist' : 'Add ' + productName + ' to wishlist')
            : (removing ? 'Remove from wishlist' : 'Add to wishlist')
        );
      }
      var svg = action.querySelector('svg');
      if (svg) {
        svg.setAttribute('aria-hidden', 'true');
        svg.setAttribute('focusable', 'false');
      }
    }
  }

  function productCardOverlayUrl(overlay) {
    var card = overlay && overlay.closest('.t4s-product');
    var titleLink = card && card.querySelector('.t4s-product-title a[href]');
    return (titleLink && titleLink.href) || overlay.getAttribute('data-product-url') || '';
  }

  function productLinkMirrorUrl(mirror) {
    return (mirror && mirror.getAttribute('data-product-url')) || '';
  }

  function duplicatePointerUrl(mirror) {
    if (!mirror) return '';
    if (mirror.matches('[data-search-product-image]')) {
      var searchCard = mirror.closest('.t4s-widget__pr');
      var searchTitle = searchCard && searchCard.querySelector('.t4s-widget__pr-title[href]');
      return (searchTitle && searchTitle.href) || mirror.getAttribute('data-product-url') || '';
    }
    var menuUrl = mirror.getAttribute('data-menu-url') || '';
    return menuUrl ? new URL(menuUrl, document.baseURI).href : '';
  }

  function followPointerMirror(event, mirror) {
    var url = duplicatePointerUrl(mirror);
    if (!url) return;
    event.preventDefault();
    if (event.ctrlKey || event.metaKey || event.shiftKey) {
      window.open(url, '_blank', 'noopener');
    } else {
      window.location.assign(url);
    }
  }

  function onProductCardActionKeydown(event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    var action = event.target && event.target.closest
      ? event.target.closest(
          'a[role="button"][data-action-quickview], ' +
            'a[role="button"][data-action-wishlist], ' +
            'a[role="button"][data-action-atc], ' +
            'a[role="button"].t4s-pr-addtocart, ' +
            'a[role="button"].t4s-page_cart__edit, ' +
            'a[role="button"].t4s-mini_cart__edit'
        )
      : null;
    if (!action) return;
    event.preventDefault();
    action.click();
  }

  function onProductCardPointerClick(event) {
    var target = event.target && event.target.closest ? event.target : null;
    if (!target) return;

    var duplicateMirror = target.closest('[data-menu-duplicate-link], [data-search-product-image]');
    if (duplicateMirror) {
      followPointerMirror(event, duplicateMirror);
      return;
    }

    var productMirror = target.closest('[data-product-link-mirror]');
    if (productMirror) {
      var productMirrorUrl = productLinkMirrorUrl(productMirror);
      if (!productMirrorUrl) return;
      event.preventDefault();
      if (event.ctrlKey || event.metaKey || event.shiftKey) {
        window.open(productMirrorUrl, '_blank', 'noopener');
      } else {
        window.location.assign(productMirrorUrl);
      }
      return;
    }

    var hrefBackedAction = target.closest(
      'a[role="button"][data-action-quickview], ' +
        'a[role="button"].t4s-pr-addtocart, ' +
        'a[role="button"].t4s-page_cart__edit, ' +
        'a[role="button"].t4s-mini_cart__edit'
    );
    if (hrefBackedAction) {
      var actionUrl = hrefBackedAction.getAttribute('data-product-url');
      if (actionUrl) {
        hrefBackedAction.setAttribute('href', actionUrl);
        setTimeout(function () {
          if (hrefBackedAction.getAttribute('href') === actionUrl) {
            hrefBackedAction.removeAttribute('href');
          }
        }, 0);
      }
      return;
    }

    var overlay = target.closest('[data-product-card-overlay]');
    if (!overlay) return;
    var url = productCardOverlayUrl(overlay);
    if (!url) return;
    event.preventDefault();
    if (event.ctrlKey || event.metaKey || event.shiftKey) {
      window.open(url, '_blank', 'noopener');
    } else {
      window.location.assign(url);
    }
  }

  function onProductCardAuxClick(event) {
    if (event.button !== 1 || !event.target || !event.target.closest) return;
    var duplicateMirror = event.target.closest('[data-menu-duplicate-link], [data-search-product-image]');
    if (duplicateMirror) {
      var duplicateUrl = duplicatePointerUrl(duplicateMirror);
      if (!duplicateUrl) return;
      event.preventDefault();
      window.open(duplicateUrl, '_blank', 'noopener');
      return;
    }
    var productMirror = event.target.closest('[data-product-link-mirror]');
    if (productMirror) {
      var productMirrorUrl = productLinkMirrorUrl(productMirror);
      if (!productMirrorUrl) return;
      event.preventDefault();
      window.open(productMirrorUrl, '_blank', 'noopener');
      return;
    }
    var overlay = event.target.closest('[data-product-card-overlay]');
    if (!overlay) return;
    var url = productCardOverlayUrl(overlay);
    if (!url) return;
    event.preventDefault();
    window.open(url, '_blank', 'noopener');
  }

  /*
   * Heading order: Shopify Customer Privacy opt-out success uses h3 after the
   * page h1 (skips h2). It is a status message, not a section heading.
   */
  function demotePrivacyOptOutHeadings(root) {
    var nodes = root.querySelectorAll('h3.pc--opt-out-form-message');
    for (var i = 0; i < nodes.length; i++) {
      var h = nodes[i];
      if (h.getAttribute('data-a11y-demoted') === '1') continue;
      var p = document.createElement('p');
      p.className = h.className;
      p.setAttribute('role', 'status');
      p.setAttribute('data-a11y-demoted', '1');
      while (h.firstChild) p.appendChild(h.firstChild);
      h.parentNode.replaceChild(p, h);
    }
  }

  /* Replace a non-interactive element while preserving its attributes/content. */
  function replaceElementTag(el, tagName) {
    if (!el || !el.parentNode) return el;
    var replacement = document.createElement(tagName);
    for (var i = 0; i < el.attributes.length; i++) {
      replacement.setAttribute(el.attributes[i].name, el.attributes[i].value);
    }
    while (el.firstChild) replacement.appendChild(el.firstChild);
    el.parentNode.replaceChild(replacement, el);
    return replacement;
  }

  /* R1 heading-order findings: the 404 text is copy, related articles a section. */
  function repairHeadingOrder(root) {
    var errors = root.querySelectorAll('h3.error-404-subtext');
    for (var i = 0; i < errors.length; i++) replaceElementTag(errors[i], 'p');

    var related = root.querySelectorAll('h3.t4s-article-related-heading, h4.t4s-article-related-heading');
    for (var j = 0; j < related.length; j++) replaceElementTag(related[j], 'h2');

    var relatedCards = root.querySelectorAll('.t4s-article-related h5.t4s-post-title');
    for (var k = 0; k < relatedCards.length; k++) replaceElementTag(relatedCards[k], 'h3');
  }

  /*
   * Shopify policy copy is merchant-editable and can begin with h3 beneath the
   * template h1. Normalize only skipped levels inside the policy body, keeping
   * the visible text and all attributes unchanged.
   */
  function normalizePolicyHeadingOrder(root) {
    var scope = root || document;
    var bodies = scope.querySelectorAll('.shopify-policy__body');
    for (var i = 0; i < bodies.length; i++) {
      var previousLevel = 1;
      var headings = bodies[i].querySelectorAll('h2, h3, h4, h5, h6');
      for (var j = 0; j < headings.length; j++) {
        var heading = headings[j];
        var level = parseInt(heading.tagName.slice(1), 10);
        if (level > previousLevel + 1) {
          heading = replaceElementTag(heading, 'h' + (previousLevel + 1));
          level = previousLevel + 1;
        }
        previousLevel = level;
      }
    }
  }

  /*
   * WAVE flags very long catalog-image alternatives. Retain the product name,
   * but omit merchant SEO suffixes that duplicate description copy.
   */
  function normalizeLongProductImageAlt(root) {
    var scope = root || document;
    var images = scope.querySelectorAll('.t4s-product img[alt]');
    for (var i = 0; i < images.length; i++) {
      var alt = (images[i].getAttribute('alt') || '').replace(/\s+/g, ' ').trim();
      if (alt.length <= 100) continue;
      var card = images[i].closest('.t4s-product');
      var title = card && card.querySelector('.t4s-product-title a[href]');
      var name = ((title && title.textContent) || alt).replace(/\s+/g, ' ').trim();
      name = name.split('|')[0].trim();
      if (name.length > 80) {
        name = name.slice(0, 80).replace(/\s+\S*$/, '').trim();
      }
      if (name) images[i].setAttribute('alt', name);
    }
  }

  /*
   * WAVE title_redundant: remove native tooltip text only when it duplicates
   * the link's existing visible or ARIA name. Keep external-link description
   * references because they convey separate destination behavior.
   */
  function removeRedundantProductTitles(root) {
    var scope = root || document;
    var links = scope.querySelectorAll(
      '.t4s-product__info-container a[title][aria-label], ' +
      '.jm-reviewer-info__name[title], ' +
      'main a[title]'
    );
    for (var i = 0; i < links.length; i++) {
      var title = (links[i].getAttribute('title') || '').replace(/\s+/g, ' ').trim();
      var label = (links[i].getAttribute('aria-label') || '').replace(/\s+/g, ' ').trim();
      var text = (links[i].textContent || '').replace(/\s+/g, ' ').trim();
      if (title && (title === label || title === text)) links[i].removeAttribute('title');
    }
  }

  /*
   * Diagnostic 2026-08-20: color swatch buttons already contain their color
   * name as native button text. Keep the sighted custom tooltip, but make its
   * title instructional instead of a verbatim duplicate. The floating tooltip
   * is a visual mirror appended outside <main>; remove it from the accessibility
   * tree and drop aria-describedby because the button is already fully named.
   */
  function syncProductSwatchTooltips(root) {
    var scope = root || document;
    var swatches = scope.querySelectorAll('[data-swatch-item]');
    for (var i = 0; i < swatches.length; i++) {
      var swatch = swatches[i];
      var value = (
        swatch.getAttribute('data-value') ||
        swatch.textContent ||
        ''
      ).replace(/\s+/g, ' ').trim();
      if (!value) continue;
      var instructional = 'Choose ' + value + ' color';
      var title = (swatch.getAttribute('title') || '').replace(/\s+/g, ' ').trim();
      var original = (swatch.getAttribute('data-original-title') || '').replace(/\s+/g, ' ').trim();
      if (title === value) swatch.setAttribute('title', instructional);
      if (original === value) swatch.setAttribute('data-original-title', instructional);
    }

    var tooltips = scope.querySelectorAll('.t4s-tooltip');
    for (var j = 0; j < tooltips.length; j++) {
      var tooltip = tooltips[j];
      tooltip.setAttribute('aria-hidden', 'true');
      tooltip.removeAttribute('role');
      tooltip.setAttribute('data-a11y-visual-tooltip', 'true');
      if (!tooltip.id) continue;
      var described = document.querySelectorAll('[aria-describedby]');
      for (var k = 0; k < described.length; k++) {
        var ids = (described[k].getAttribute('aria-describedby') || '').split(/\s+/);
        var kept = ids.filter(function (id) { return id && id !== tooltip.id; });
        if (kept.length) described[k].setAttribute('aria-describedby', kept.join(' '));
        else described[k].removeAttribute('aria-describedby');
      }
    }
  }

  /*
   * Previous and numbered pagination links may intentionally share page=1.
   * Keep both controls, but give the numeric link the main-content fragment so
   * scanners and users receive distinct destinations.
   */
  function disambiguatePaginationLinks(root) {
    var scope = root || document;
    var navs = scope.querySelectorAll('.t4s-pagination-wrapper nav, nav.t4s-pagination');
    for (var i = 0; i < navs.length; i++) {
      var links = navs[i].querySelectorAll('a[href]');
      var previousHref = '';
      for (var j = 0; j < links.length; j++) {
        var href = links[j].getAttribute('href') || '';
        var baseHref = href.replace(/#.*$/, '');
        if (baseHref && baseHref === previousHref && !/#/.test(href)) {
          links[j].setAttribute('href', baseHref + '#MainContent');
        }
        previousHref = baseHref;
      }
    }
  }

  /*
   * On the 404 page, the inline homepage link and the immediately following
   * footer logo both target /. Preserve both useful links while letting the
   * footer logo land at the home page's main content.
   */
  function disambiguate404FooterHomeLink(root) {
    var scope = root || document;
    if (!scope.querySelector('main a[rel="home"]')) return;
    var footerHome = scope.querySelector('footer a[href="/"]');
    if (footerHome) footerHome.setAttribute('href', '/#MainContent');
  }

  /* 4.1.2 - name product-category selects injected into header/search drawers. */
  function nameSearchCategorySelects(root) {
    var nodes = root.querySelectorAll(
      'select[data-name="product_type"], form[action*="/search"] select[name="product_type"]'
    );
    for (var i = 0; i < nodes.length; i++) {
      if (!nodes[i].getAttribute('aria-label') && !nodes[i].getAttribute('aria-labelledby')) {
        nodes[i].setAttribute('aria-label', 'Product category');
      }
    }
  }

  /* 4.1.2 - the predictive-search script creates a CSS-hidden search input
   * after page load and transfers the submitted q value to it. Name both the
   * visible control and that generated control so every rendered state is
   * valid when an automated scanner captures it. The theme exposes results as
   * ordinary Tab-reachable links, not as an Arrow-operated listbox. Do not
   * advertise the unsupported combobox/list-autocomplete interaction. */
  function nameSearchInputs(root) {
    var nodes = root.querySelectorAll(
      '#t4s-search-hidden [data-input-search], ' +
      '#t4s-search-hidden [data-input-q], ' +
      '#t4s-search-hidden input[type="search"]'
    );
    for (var i = 0; i < nodes.length; i++) {
      if (!nodes[i].getAttribute('aria-label') && !nodes[i].getAttribute('aria-labelledby')) {
        nodes[i].setAttribute('aria-label', 'Search');
      }
      var drawer = nodes[i].closest('#t4s-search-hidden');
      var results = drawer && drawer.querySelector('[data-results-search]');
      var hasListboxModel = !!(
        results &&
        results.getAttribute('role') === 'listbox' &&
        results.querySelector('[role="option"]')
      );
      if (!hasListboxModel) {
        nodes[i].removeAttribute('role');
        nodes[i].removeAttribute('aria-autocomplete');
        nodes[i].removeAttribute('aria-controls');
        nodes[i].removeAttribute('aria-activedescendant');
        nodes[i].removeAttribute('aria-expanded');
        nodes[i].setAttribute('data-a11y-search-navigation', 'tab');
      }
    }
  }

  function setAutocomplete(root, selector, token) {
    var nodes = root.querySelectorAll(selector);
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].getAttribute('autocomplete') !== token) {
        nodes[i].setAttribute('autocomplete', token);
      }
    }
  }

  /* 1.3.5 / form best practice - expose applicable input purposes. */
  function enhanceFormPurposes(root) {
    setAutocomplete(root, '#contact_form_page-name, input[name="contact[name]"]', 'name');
    setAutocomplete(root, '#contact_form_page-email, input[name="contact[email]"]', 'email');
    setAutocomplete(root, '#contact_form_page-phone, input[name="contact[phone]"]', 'tel');
    setAutocomplete(root, '.t4s-newsletter__email', 'email');
    setAutocomplete(root, '#ShippingCountry_mini_cart', 'country-name');
    setAutocomplete(root, '#ShippingProvince_mini_cart', 'address-level1');
    setAutocomplete(root, '#ShippingZip_mini_cart', 'postal-code');

    var discount = root.querySelectorAll('#CartDiscountcode');
    for (var i = 0; i < discount.length; i++) {
      if (!discount[i].getAttribute('aria-label') && !discount[i].getAttribute('aria-labelledby')) {
        discount[i].setAttribute('aria-label', 'Discount code');
      }
      if (!discount[i].getAttribute('autocomplete')) {
        discount[i].setAttribute('autocomplete', 'off');
      }
    }
  }

  /* Named dialogs contain dynamic drawer content within an announced region. */
  function decorateDrawerLandmarks() {
    var configs = [
      ['t4s-search-hidden', 'Search'],
      ['t4s-filter-hidden', 'Filter products'],
      ['t4s-mini_cart', 'Shopping cart']
    ];
    for (var i = 0; i < configs.length; i++) {
      var drawer = document.getElementById(configs[i][0]);
      if (!drawer) continue;
      drawer.setAttribute('role', 'dialog');
      drawer.setAttribute('aria-modal', 'true');
      if (!drawer.getAttribute('aria-label') && !drawer.getAttribute('aria-labelledby')) {
        drawer.setAttribute('aria-label', configs[i][1]);
      }
    }
  }

  /* The currency code is already adjacent text; the flag is decorative. */
  function hideRedundantCurrencyFlagAlt(root) {
    var flags = root.querySelectorAll('img[data-img-current]');
    for (var i = 0; i < flags.length; i++) flags[i].setAttribute('alt', '');
  }

  function isCurrentlyVisible(el) {
    if (!el || el.closest('[aria-hidden="true"]')) return false;
    if (typeof el.getClientRects === 'function' && el.getClientRects().length === 0) {
      return false;
    }
    return true;
  }

  /*
   * The facets script clones complete sidebar/filter markup, including IDs.
   * Keep the original ID on the currently visible copy (so vendor selectors
   * continue to work) and give hidden/cloned copies deterministic suffixes.
   */
  function dedupeKnownIds() {
    var decorative = document.querySelectorAll('path#Forma_1');
    for (var i = 0; i < decorative.length; i++) decorative[i].removeAttribute('id');

    var nodes = document.querySelectorAll(
      '#FacetFiltersForm, [id^="blockid_"], [id^="t4s-sidebar-"], [data-a11y-original-id]'
    );
    var groups = {};
    for (var j = 0; j < nodes.length; j++) {
      var original = nodes[j].getAttribute('data-a11y-original-id') || nodes[j].id;
      if (!original) continue;
      if (!groups[original]) groups[original] = [];
      groups[original].push(nodes[j]);
    }

    for (var id in groups) {
      if (!Object.prototype.hasOwnProperty.call(groups, id)) continue;
      var group = groups[id];
      if (group.length < 2) {
        group[0].id = id;
        group[0].removeAttribute('data-a11y-original-id');
        continue;
      }

      var keeper = group[0];
      for (var k = 0; k < group.length; k++) {
        if (isCurrentlyVisible(group[k])) {
          keeper = group[k];
          break;
        }
      }
      keeper.id = id;
      keeper.removeAttribute('data-a11y-original-id');

      var suffix = 2;
      for (var m = 0; m < group.length; m++) {
        if (group[m] === keeper) continue;
        var candidate = id + '--a11y-' + suffix;
        while (document.getElementById(candidate) && document.getElementById(candidate) !== group[m]) {
          suffix++;
          candidate = id + '--a11y-' + suffix;
        }
        group[m].setAttribute('data-a11y-original-id', id);
        group[m].id = candidate;
        suffix++;
      }
    }
  }

  /* Keep legacy ads enabled while fixing merchant-controlled host/frame semantics. */
  function repairAdSemantics(root) {
    var hosts = root.querySelectorAll('div[id^="aswift_"][id$="_host"]');
    for (var i = 0; i < hosts.length; i++) {
      if (hosts[i].getAttribute('aria-label')) hosts[i].setAttribute('role', 'group');
    }
    var frames = root.querySelectorAll(
      'iframe[id^="aswift_"], iframe[src*="doubleclick.net/pagead/"]'
    );
    for (var j = 0; j < frames.length; j++) {
      var match = (frames[j].id || '').match(/^aswift_(\d+)/);
      var title = match ? 'Advertisement ' + match[1] : 'Advertisement';
      if (!frames[j].getAttribute('title') || frames[j].getAttribute('title') === 'Advertisement') {
        frames[j].setAttribute('title', title);
      }
    }
  }

  /* Close the aria-hidden carousel timing window before the debounced full pass. */
  function watchHiddenSubtreesImmediately() {
    var observer = new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        if (records[i].type === 'childList' || records[i].attributeName === 'aria-hidden') {
          syncHiddenSubtrees(document);
          nameSearchCategorySelects(document);
          nameSearchInputs(document);
          enhanceFormPurposes(document);
          decorateDrawerLandmarks();
          hideRedundantCurrencyFlagAlt(document);
          dedupeKnownIds();
          repairAdSemantics(document);
          return;
        }
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-hidden']
    });
  }

  /*
   * 1.3.1 Info and Relationships - the slider library injects a wrapper div
   * straight into the tab strip's <ul>, which breaks the list structure it
   * announces. The strip is decorative navigation, so drop the list semantics
   * rather than announce a broken list.
   */
  function unlistSliderLists(root) {
    var lists = root.querySelectorAll('ul.t4s-tabs-ul');
    for (var i = 0; i < lists.length; i++) {
      var ul = lists[i];
      if (!ul.querySelector(':scope > div')) continue;
      ul.setAttribute('role', 'group');
      if (!ul.getAttribute('aria-label')) {
        ul.setAttribute('aria-label', 'Product collection tabs');
      }
      var items = ul.querySelectorAll('li');
      for (var j = 0; j < items.length; j++) items[j].setAttribute('role', 'none');
    }
  }

  /*
   * 4.1.2 - the review widget points aria-controls at an element id that is
   * not in the page, so assistive technology is given a dangling reference.
   * An absent attribute is better than one that resolves to nothing.
   */
  function dropDanglingRefs(root) {
    var attrs = ['aria-controls', 'aria-describedby', 'aria-labelledby'];
    for (var a = 0; a < attrs.length; a++) {
      var nodes = root.querySelectorAll('[' + attrs[a] + ']');
      for (var i = 0; i < nodes.length; i++) {
        var ids = (nodes[i].getAttribute(attrs[a]) || '').split(/\s+/);
        var kept = [];
        for (var j = 0; j < ids.length; j++) {
          if (ids[j] && document.getElementById(ids[j])) kept.push(ids[j]);
        }
        if (kept.length === ids.filter(Boolean).length) continue;
        if (kept.length) nodes[i].setAttribute(attrs[a], kept.join(' '));
        else nodes[i].removeAttribute(attrs[a]);
      }
    }
  }

  /*
   * 4.1.2 - keep menu opener expanded state in sync with the drawer that the
   * theme already toggles via aria-hidden.
   */
  function syncMenuExpanded() {
    var drawer = document.getElementById('t4s-menu-drawer');
    if (!drawer) return;
    var open = drawer.getAttribute('aria-hidden') === 'false';
    var openers = document.querySelectorAll(
      '[data-menu-drawer][aria-controls="t4s-menu-drawer"]'
    );
    for (var i = 0; i < openers.length; i++) {
      openers[i].setAttribute('aria-expanded', open ? 'true' : 'false');
    }
  }

  /*
   * WAVE mobile currency remediation (2026-08-08).
   * These anchors are scripted disclosure/choice controls whose common "/"
   * fallback produces four redundant-link alerts. Keep the vendor anchor tag
   * and data hooks, but expose the controls as buttons without link targets.
   */
  function syncMobileCurrencyControls() {
    var item = document.getElementById('item_mb_cur');
    if (!item) return;
    var drawer = document.getElementById('t4s-menu-drawer');
    var drawerOpen = !!drawer && drawer.getAttribute('aria-hidden') === 'false';
    var submenu = item.querySelector(':scope > .t4s-sub-menu');
    var submenuOpen = item.classList.contains('is--opend');
    if (submenu) {
      if (!submenu.id) submenu.id = 'a11y-mobile-currency-list';
    }

    var opener = item.querySelector(':scope > a');
    if (opener) {
      opener.removeAttribute('href');
      opener.setAttribute('role', 'button');
      opener.setAttribute('tabindex', drawerOpen ? '0' : '-1');
      opener.setAttribute('aria-expanded', submenuOpen ? 'true' : 'false');
      if (submenu) opener.setAttribute('aria-controls', submenu.id);
      var current = opener.querySelector('[data-current]');
      var currentText = current ? (current.textContent || '').replace(/\s+/g, ' ').trim() : '';
      opener.setAttribute('aria-label', currentText ? 'Currency, current ' + currentText : 'Currency');
    }

    var choices = item.querySelectorAll('a[data-currency-item]');
    for (var i = 0; i < choices.length; i++) {
      var choice = choices[i];
      var temporary = choice.hasAttribute('data-currency-temp') && choice.classList.contains('t4s-d-none');
      choice.removeAttribute('href');
      choice.setAttribute('role', 'button');
      choice.setAttribute('aria-pressed', choice.classList.contains('is--selected') ? 'true' : 'false');
      choice.setAttribute('tabindex', drawerOpen && submenuOpen && !temporary ? '0' : '-1');
      if (temporary) choice.setAttribute('aria-hidden', 'true');
      else choice.removeAttribute('aria-hidden');
    }
  }

  function onMobileCurrencyKeydown(event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    var control = event.target && event.target.closest
      ? event.target.closest('#item_mb_cur > a[role="button"], #item_mb_cur a[data-currency-item][role="button"]')
      : null;
    if (!control || control.getAttribute('aria-hidden') === 'true') return;
    event.preventDefault();
    control.click();
  }

  function onMobileCurrencyClick(event) {
    if (!event.target || !event.target.closest || !event.target.closest('#item_mb_cur')) return;
    setTimeout(syncMobileCurrencyControls, 0);
    setTimeout(syncMobileCurrencyControls, 180);
  }

  /*
   * 4.1.3 Status Messages - cart updates change a visible count but do not
   * expose a status region, so screen readers miss successful Add to cart.
   * Errors/warnings from T4SThemeSP.Notices (#t4s-notices__wrapper) are also
   * announced (assertive).
   */
  var statusEl = null;
  var lastCartCount = null;
  var statusClearTimer = null;
  var lastNoticeText = '';

  function ensureStatusRegion() {
    if (statusEl && document.body.contains(statusEl)) return statusEl;
    statusEl = document.getElementById('a11y-status');
    if (!statusEl) {
      statusEl = document.createElement('div');
      statusEl.id = 'a11y-status';
      statusEl.className = 'a11y-sr-only';
      statusEl.setAttribute('role', 'status');
      statusEl.setAttribute('aria-live', 'polite');
      statusEl.setAttribute('aria-atomic', 'true');
      document.body.appendChild(statusEl);
    }
    /* Reaudit: do not make #a11y-status focusable; live region only. */
    statusEl.removeAttribute('tabindex');
    return statusEl;
  }

  /*
   * Theme ProductAjax sets aria-disabled=true on the ATC control while the
   * request runs. NVDA announces that as "unavailable"/"недоступно" if the
   * control is (or was just) focused. Strip aria-disabled for AT only (theme
   * still has is--loading / its own guards), blur immediately, and do not
   * refocus ATC until after the mini-cart would have opened.
   */
  function isAtcControl(el) {
    if (!el || !el.closest) return null;
    return (
      el.closest(
        '[data-atc-form], [data-action-atc], form[action*="/cart/add"] [type="submit"], .t4s-product-form__submit, .t4s-sticky-atc button'
      ) || null
    );
  }

  function themeMarksAtcBusy(el) {
    return (
      !!el &&
      (el.getAttribute('aria-disabled') === 'true' ||
        el.getAttribute('data-a11y-theme-aria-disabled') === '1' ||
        el.classList.contains('is--loading') ||
        !!el.disabled)
    );
  }

  function isAtcBusy(el) {
    return themeMarksAtcBusy(el);
  }

  function blurAtcIfFocused(btn) {
    if (!btn) return;
    try {
      var ae = document.activeElement;
      if (ae === btn || (btn.contains && btn.contains(ae))) {
        btn.blur();
      }
    } catch (e) {
      /* ignore */
    }
  }

  /* Remove aria-disabled so NVDA does not say unavailable; remember for busy checks. */
  function suppressAtcAriaDisabled(el) {
    if (!el) return;
    if (el.getAttribute('aria-disabled') === 'true') {
      el.setAttribute('data-a11y-theme-aria-disabled', '1');
      el.removeAttribute('aria-disabled');
    }
    blurAtcIfFocused(el);
  }

  function onAtcBusy(btn) {
    if (!btn) return;
    miniCartLastFocus = btn;
    pendingAtcRestore = true;
    suppressAtcAriaDisabled(btn);
    announce('Adding to cart.');
    scheduleAtcFocusRestore();
  }


  var pendingAtcRestore = false;
  var atcRestoreTimer = null;

  function findReplacementAtc() {
    var selectors = [
      'form[action*="/cart/add"] button[name="add"]',
      'form[action*="/cart/add"] [type="submit"]',
      'form[action*="/cart/add"] button.t4s-product-form__submit',
      '[data-atc-form]',
      'button.t4s-product-form__submit',
      '.t4s-main-product button[data-action-atc]',
      '.t4s-sticky-atc__atc'
    ];
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el && !isAtcBusy(el)) return el;
    }
    return null;
  }

  function focusReplacementAtc() {
    if (!pendingAtcRestore) return;
    var drawer = document.getElementById('t4s-mini_cart');
    if (drawer && isMiniCartOpen(drawer)) {
      pendingAtcRestore = false;
      return;
    }
    var ae = document.activeElement;
    if (ae && drawer && drawer.contains(ae)) {
      pendingAtcRestore = false;
      return;
    }
    if (ae && isAtcControl(ae) && !isAtcBusy(ae)) {
      pendingAtcRestore = false;
      return;
    }
    var btn = findReplacementAtc();
    if (!btn) return;
    try {
      btn.focus({ preventScroll: true });
    } catch (e) {
      try {
        btn.focus();
      } catch (e2) {
        /* ignore */
      }
    }
    if (document.activeElement === btn || (btn.contains && btn.contains(document.activeElement))) {
      pendingAtcRestore = false;
    }
  }

  function scheduleAtcFocusRestore() {
    pendingAtcRestore = true;
    if (atcRestoreTimer) clearTimeout(atcRestoreTimer);
    /* Single late attempt only if mini-cart never took focus (failed add / no drawer). */
    atcRestoreTimer = window.setTimeout(function () {
      atcRestoreTimer = null;
      focusReplacementAtc();
      pendingAtcRestore = false;
    }, 1000);
  }


  function restoreAtcFocusIfNeeded(btn) {
    if (!btn || !document.body.contains(btn)) return;
    if (isAtcBusy(btn)) return;
    var drawer = document.getElementById('t4s-mini_cart');
    if (drawer && isMiniCartOpen(drawer)) return;
    if (drawer && drawer.contains(document.activeElement)) return;
    if (document.activeElement && document.activeElement !== document.body) {
      var ae = document.activeElement;
      if (ae.id === 'a11y-status') {
        /* fall through */
      } else if (ae !== btn && !(btn.contains && btn.contains(ae))) {
        return;
      }
    }
    try {
      btn.focus({ preventScroll: true });
    } catch (e) {
      try {
        btn.focus();
      } catch (e2) {
        /* ignore */
      }
    }
  }

  function watchAtcBusyFocus() {
    document.addEventListener(
      'click',
      function (e) {
        var btn = isAtcControl(e.target);
        if (!btn) return;
        miniCartLastFocus = btn;
        blurAtcIfFocused(btn);
        window.setTimeout(function () {
          if (themeMarksAtcBusy(btn) || btn.getAttribute('aria-disabled') === 'true') {
            suppressAtcAriaDisabled(btn);
            onAtcBusy(btn);
          }
        }, 0);
      },
      true
    );

    document.addEventListener(
      'keydown',
      function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        var btn = isAtcControl(e.target);
        if (!btn) return;
        miniCartLastFocus = btn;
        /* After theme keydown handlers: strip aria-disabled before NVDA speaks. */
        window.setTimeout(function () {
          suppressAtcAriaDisabled(btn);
          if (themeMarksAtcBusy(btn)) onAtcBusy(btn);
        }, 0);
      },
      true
    );

    var observer = new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var rec = records[i];
        var el = rec.target;
        if (!el || el.nodeType !== 1) continue;
        if (!isAtcControl(el) && !(el.matches && el.matches('[data-atc-form], [data-action-atc]'))) {
          continue;
        }
        if (el.getAttribute('aria-disabled') === 'true') {
          suppressAtcAriaDisabled(el);
        }
        var busy = themeMarksAtcBusy(el);
        if (!busy) {
          if (el.getAttribute('data-a11y-atc-busy') === '1') {
            el.removeAttribute('data-a11y-atc-busy');
            el.removeAttribute('data-a11y-theme-aria-disabled');
            /* Do not yank focus back to ATC — mini-cart or late restore owns it. */
          }
          continue;
        }
        if (el.getAttribute('data-a11y-atc-busy') === '1') continue;
        el.setAttribute('data-a11y-atc-busy', '1');
        onAtcBusy(isAtcControl(el) || el);
      }
    });
    observer.observe(document.body, {
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-disabled', 'class']
    });
  }

  function announce(message, opts) {
    if (!message) return;
    var assertive = opts && opts.assertive;
    var el = ensureStatusRegion();
    if (assertive) {
      el.setAttribute('role', 'alert');
      el.setAttribute('aria-live', 'assertive');
    } else {
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
    }
    el.textContent = '';
    window.setTimeout(function () {
      el.textContent = message;
      if (document.activeElement === el) {
        var back = miniCartLastFocus;
        if (back && document.body.contains(back)) {
          try {
            back.focus({ preventScroll: true });
          } catch (e) {
            try {
              back.focus();
            } catch (e2) {
              /* ignore */
            }
          }
        } else {
          try {
            el.blur();
          } catch (e3) {
            /* ignore */
          }
        }
      }
    }, 50);
    if (statusClearTimer) clearTimeout(statusClearTimer);
    statusClearTimer = setTimeout(function () {
      if (el.textContent === message) el.textContent = '';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
    }, 8000);
  }

  function readCartCount() {
    var node = document.querySelector('[data-cart-count]');
    if (node) {
      var n = parseInt((node.textContent || '').replace(/[^\d]/g, ''), 10);
      if (!isNaN(n)) return n;
    }
    var cls = document.documentElement.className || '';
    var m = cls.match(/(?:^|\s)t4s-cart-count-(\d+)(?:\s|$)/);
    return m ? parseInt(m[1], 10) : null;
  }

  function productTitleNearFocus() {
    var root =
      (document.activeElement &&
        document.activeElement.closest(
          '.t4s-product, .t4s-product-wrapper, form[action*="/cart/add"], .t4s-sticky-atc'
        )) ||
      document.querySelector('.t4s-product__title, h1.t4s-product__title, h1');
    if (!root) return '';
    var title = root.querySelector(
      '.t4s-product__title, h1.t4s-product__title, [data-product-title], h1'
    );
    if (!title && root.matches && root.matches('h1, .t4s-product__title')) {
      title = root;
    }
    return title ? (title.textContent || '').replace(/\s+/g, ' ').trim() : '';
  }

  function maybeAnnounceCartChange() {
    var count = readCartCount();
    if (count === null) return;
    if (lastCartCount === null) {
      lastCartCount = count;
      return;
    }
    if (count === lastCartCount) return;
    var prev = lastCartCount;
    lastCartCount = count;
    /* R2 cart quantity updates have their own accurate status/focus handler. */
    if (
      window.__a11yCartQuantityPending ||
      Date.now() < (window.__a11yCartQuantitySuppressUntil || 0)
    ) return;
    if (count > prev) {
      var title = productTitleNearFocus();
      var itemWord = count === 1 ? 'item' : 'items';
      var msg = title
        ? title + ' added to cart. Cart contains ' + count + ' ' + itemWord + '.'
        : 'Item added to cart. Cart contains ' + count + ' ' + itemWord + '.';
      announce(msg);
      scheduleAtcFocusRestore();
    }
  }

  function watchCartStatus() {
    ensureStatusRegion();
    lastCartCount = readCartCount();
    var cartObserver = new MutationObserver(function () {
      maybeAnnounceCartChange();
    });
    cartObserver.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class']
    });
    cartObserver.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  /*
   * 4.1.3 - theme toast (#t4s-notices__wrapper.is--show) is visual only.
   * Copy its message into the live region when it appears.
   */
  function maybeAnnounceNotice() {
    var wrap = document.getElementById('t4s-notices__wrapper');
    if (!wrap || !wrap.classList.contains('is--show')) {
      lastNoticeText = '';
      return;
    }
    var mess = wrap.querySelector('.t4s-notices__mess');
    var text = mess
      ? (mess.textContent || '').replace(/\s+/g, ' ').trim()
      : '';
    if (!text || text === lastNoticeText) return;
    lastNoticeText = text;
    var status = (wrap.getAttribute('data-notices-status') || '').toLowerCase();
    var assertive = status !== 'success';
    announce(text, { assertive: assertive });
  }

  function watchCartErrors() {
    var pending = null;
    var observer = new MutationObserver(function () {
      if (pending) return;
      pending = setTimeout(function () {
        pending = null;
        maybeAnnounceNotice();
      }, 50);
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'data-notices-status']
    });
    maybeAnnounceNotice();
  }

  /*
   * 2.1.1 / 2.4.3 - after Add to cart the theme opens #t4s-mini_cart and sets
   * aria-hidden=false, but leaves keyboard focus on the product page. Move
   * focus into the drawer, trap Tab while open, restore focus on close.
   */
  var miniCartOpen = false;
  var miniCartLastFocus = null;
  var miniCartFocusTimers = [];

  /*
   * Theme sets aria-hidden=false when open. Requiring the html class as well
   * caused false "closed" during the open race → focus restored to ATC and Tab
   * escaped to the browser chrome (NVDA Defect 2 / FAIL 1).
   */
  function isMiniCartOpen(drawer) {
    if (!drawer) return false;
    if (drawer.getAttribute('aria-hidden') === 'true') return false;
    if (drawer.getAttribute('aria-hidden') === 'false') return true;
    return document.documentElement.classList.contains('is--opend-drawer');
  }

  function clearMiniCartFocusTimers() {
    for (var i = 0; i < miniCartFocusTimers.length; i++) {
      clearTimeout(miniCartFocusTimers[i]);
    }
    miniCartFocusTimers = [];
  }

  function getFocusableIn(container) {
    var nodes = container.querySelectorAll(FOCUSABLE);
    var out = [];
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.getAttribute('tabindex') === '-1') continue;
      if (el.hasAttribute('disabled')) continue;
      if (el.getAttribute('aria-hidden') === 'true') continue;
      if (el.closest('[aria-hidden="true"]')) continue;
      var toolPanel = el.closest('.t4s-mini_cart-tool__content');
      if (toolPanel && !toolPanel.classList.contains('is--opend')) continue;
      out.push(el);
    }
    return out;
  }

  function pickMiniCartFocusTarget(drawer) {
    var closeBtn = drawer.querySelector(
      '[data-drawer-close], .t4s-drawer__close, button.t4s-drawer__close'
    );
    if (closeBtn && closeBtn.getAttribute('tabindex') !== '-1') return closeBtn;
    var checkout = drawer.querySelector(
      'a[href*="/checkout"], button[name="checkout"], [data-checkout], .t4s-mini_cart__checkout a, .t4s-btn__checkout'
    );
    if (checkout && checkout.getAttribute('tabindex') !== '-1') return checkout;
    var list = getFocusableIn(drawer);
    return list.length ? list[0] : drawer;
  }

  function focusIntoMiniCart(drawer) {
    if (!drawer || !isMiniCartOpen(drawer)) return false;
    if (drawer.contains(document.activeElement)) return true;
    syncHiddenSubtrees(document);
    var target = pickMiniCartFocusTarget(drawer);
    if (!target || typeof target.focus !== 'function') return false;
    try {
      target.focus({ preventScroll: true });
    } catch (e) {
      try {
        target.focus();
      } catch (e2) {
        return false;
      }
    }
    return drawer.contains(document.activeElement);
  }

  function scheduleMiniCartFocus(drawer) {
    clearMiniCartFocusTimers();
    var delays = [0, 80, 200, 450, 900];
    for (var i = 0; i < delays.length; i++) {
      (function (delay) {
        miniCartFocusTimers.push(
          setTimeout(function () {
            focusIntoMiniCart(drawer);
          }, delay)
        );
      })(delays[i]);
    }
  }

  function onMiniCartOpen(drawer) {
    pendingAtcRestore = false;
    if (atcRestoreTimer) {
      clearTimeout(atcRestoreTimer);
      atcRestoreTimer = null;
    }
    var wasOpen = miniCartOpen;
    miniCartOpen = true;
    if (!wasOpen) {
      if (
        !miniCartLastFocus ||
        !document.contains(miniCartLastFocus) ||
        drawer.contains(miniCartLastFocus)
      ) {
        miniCartLastFocus = document.activeElement;
      }
      syncHiddenSubtrees(document);
      if (!drawer.hasAttribute('tabindex')) drawer.setAttribute('tabindex', '-1');
      scheduleMiniCartFocus(drawer);
      return;
    }
    /* Already open: only re-pull focus if it escaped the drawer (ATC restore race). */
    if (!drawer.contains(document.activeElement)) {
      focusIntoMiniCart(drawer);
    }
  }

  function onMiniCartClose(drawer) {
    if (!miniCartOpen) return;
    miniCartOpen = false;
    clearMiniCartFocusTimers();
    var restore = miniCartLastFocus;
    miniCartLastFocus = null;
    syncHiddenSubtrees(document);
    if (restore && document.contains(restore) && typeof restore.focus === 'function') {
      setTimeout(function () {
        if (isMiniCartOpen(document.getElementById('t4s-mini_cart'))) return;
        try {
          restore.focus({ preventScroll: true });
        } catch (e) {
          try {
            restore.focus();
          } catch (e2) {
            /* ignore */
          }
        }
      }, 50);
    }
  }

  function syncMiniCartFocusState() {
    var drawer = document.getElementById('t4s-mini_cart');
    if (!drawer) return;
    if (isMiniCartOpen(drawer)) onMiniCartOpen(drawer);
    else onMiniCartClose(drawer);
  }

  function trapMiniCartTab(e) {
    if (e.key !== 'Tab') return;
    var drawer = document.getElementById('t4s-mini_cart');
    if (!drawer || !isMiniCartOpen(drawer)) return;
    miniCartOpen = true;
    syncMiniCartToolPanels(drawer);
    var list = getFocusableIn(drawer);
    if (!list.length) {
      e.preventDefault();
      try {
        drawer.focus();
      } catch (err) {
        /* ignore */
      }
      return;
    }
    var first = list[0];
    var last = list[list.length - 1];
    var active = document.activeElement;
    /* If focus landed in a closed tool panel, pull back into the active cycle. */
    var closedTool = null;
    if (active && active.closest) {
      closedTool = active.closest('.t4s-mini_cart-tool__content');
      if (closedTool && closedTool.classList.contains('is--opend')) closedTool = null;
    }
    if (closedTool) {
      e.preventDefault();
      (e.shiftKey ? last : first).focus();
      return;
    }
    if (!drawer.contains(active)) {
      e.preventDefault();
      (e.shiftKey ? last : first).focus();
      return;
    }
    if (e.shiftKey && active === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && active === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function rememberOpener(e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (
      t.closest(
        '[data-drawer-options*="t4s-mini_cart"], form[action*="/cart/add"] button, form[action*="/cart/add"] [type="submit"], [name="add"], .t4s-product-form__submit, .t4s-sticky-atc button'
      )
    ) {
      miniCartLastFocus = t.closest('button, a, input, [tabindex]') || t;
    }
  }

  function watchMiniCartFocus() {
    var drawer = document.getElementById('t4s-mini_cart');
    if (!drawer) return;

    document.addEventListener('click', rememberOpener, true);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') rememberOpener(e);
      trapMiniCartTab(e);
    }, true);

    drawer.addEventListener('opendDrawer', function () {
      onMiniCartOpen(drawer);
    });

    var attrObserver = new MutationObserver(function () {
      syncMiniCartFocusState();
    });
    attrObserver.observe(drawer, {
      attributes: true,
      attributeFilter: ['aria-hidden', 'class']
    });
    attrObserver.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class']
    });

    syncMiniCartFocusState();
  }

  /*
   * 2.1.1 / 2.4.3 / 4.1.2 — timed newsletter Magnific Popup opens with
   * role=dialog on #t4s-popup__newsletter (Liquid), but MFP often parks
   * focus on a wrapper DIV that has no dialog name. Move focus to Close or
   * the heading, trap Tab inside the dialog, restore focus on close.
   * (AT-PRIV-019)
   */
  var newsletterLastFocus = null;
  var newsletterOpen = false;

  function newsletterDialog() {
    return document.getElementById('t4s-popup__newsletter');
  }

  function newsletterIsOpen(dialog) {
    if (!dialog) return false;
    if (dialog.classList.contains('mfp-hide')) return false;
    if (dialog.closest('.mfp-content')) return true;
    if (document.body.classList.contains('mfp-ready')) return true;
    var style = window.getComputedStyle(dialog);
    return style.display !== 'none' && style.visibility !== 'hidden';
  }

  function isNewsletterTabbable(el) {
    if (!el || el.disabled) return false;
    if (el.getAttribute('tabindex') === '-1') return false;
    if (el.getAttribute('aria-hidden') === 'true') return false;
    if (el.closest('[aria-hidden="true"]')) return false;
    if (typeof el.getClientRects === 'function' && el.getClientRects().length === 0) {
      return false;
    }
    var style = window.getComputedStyle(el);
    if (style.visibility === 'hidden' || style.display === 'none') return false;
    return true;
  }

  function newsletterFocusables(dialog) {
    var root = (dialog && dialog.closest('.mfp-wrap')) || dialog;
    if (!root) return [];
    /* Explicit list — do not use bare `button`/`input` with tabindex=-1. */
    var nodes = root.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
    var out = [];
    for (var i = 0; i < nodes.length; i++) {
      if (isNewsletterTabbable(nodes[i])) out.push(nodes[i]);
    }
    return out;
  }

  function ensureNewsletterDialog(dialog) {
    if (!dialog.getAttribute('role')) dialog.setAttribute('role', 'dialog');
    dialog.setAttribute('aria-modal', 'true');
    if (!dialog.hasAttribute('tabindex')) dialog.setAttribute('tabindex', '-1');
    var heading = dialog.querySelector(
      '.t4s-news-heading, #t4s-newsletter-heading-a11y, h4, h3, h2'
    );
    if (heading) {
      if (!heading.id) heading.id = 't4s-newsletter-heading-a11y';
      if (!dialog.getAttribute('aria-labelledby') && !dialog.getAttribute('aria-label')) {
        dialog.setAttribute('aria-labelledby', heading.id);
      }
      /* Programmatic focus only — keep out of Tab cycle. */
      heading.setAttribute('tabindex', '-1');
    } else if (!dialog.getAttribute('aria-label') && !dialog.getAttribute('aria-labelledby')) {
      dialog.setAttribute('aria-label', 'Newsletter signup');
    }
    return heading;
  }

  function focusEl(el) {
    if (!el || typeof el.focus !== 'function') return;
    try {
      el.focus({ preventScroll: true });
    } catch (e) {
      try {
        el.focus();
      } catch (e2) {
        /* ignore */
      }
    }
  }

  function onNewsletterOpen(dialog) {
    if (!newsletterLastFocus) {
      newsletterLastFocus = document.activeElement;
    }
    ensureNewsletterDialog(dialog);
    var nodes = newsletterFocusables(dialog);
    var closeBtn =
      document.querySelector('.mfp-wrap .mfp-close') ||
      dialog.querySelector('.mfp-close, [data-mfp-close]');
    var target =
      (closeBtn && isNewsletterTabbable(closeBtn) && closeBtn) ||
      nodes[0] ||
      dialog;
    /* MFP may focus a nameless wrapper first; retarget shortly after open. */
    focusEl(target);
    setTimeout(function () {
      if (newsletterIsOpen(dialog)) focusEl(target);
    }, 60);
  }

  function onNewsletterClose() {
    var restore = newsletterLastFocus;
    newsletterLastFocus = null;
    if (restore && document.contains(restore) && typeof restore.focus === 'function') {
      focusEl(restore);
    }
  }

  function trapNewsletterTab(e) {
    if (e.key !== 'Tab') return;
    var dialog = newsletterDialog();
    if (!newsletterIsOpen(dialog)) return;
    var nodes = newsletterFocusables(dialog);
    if (!nodes.length) return;
    var first = nodes[0];
    var last = nodes[nodes.length - 1];
    var active = document.activeElement;
    var idx = nodes.indexOf(active);
    if (e.shiftKey) {
      if (idx <= 0) {
        e.preventDefault();
        focusEl(last);
      }
    } else if (idx === -1 || idx === nodes.length - 1) {
      e.preventDefault();
      focusEl(first);
    }
  }

  function syncNewsletterFocusState() {
    var dialog = newsletterDialog();
    var open = newsletterIsOpen(dialog);
    if (open && !newsletterOpen) {
      newsletterOpen = true;
      onNewsletterOpen(dialog);
    } else if (!open && newsletterOpen) {
      newsletterOpen = false;
      onNewsletterClose();
    } else if (open && dialog) {
      /* Keep attrs if MFP rewrites the node */
      ensureNewsletterDialog(dialog);
      var active = document.activeElement;
      if (
        active &&
        active !== dialog &&
        !dialog.contains(active) &&
        !(active.closest && active.closest('.mfp-wrap'))
      ) {
        /* ignore — focus elsewhere */
      } else if (
        active &&
        active.matches &&
        active.matches('.mfp-content, .mfp-container, .mfp-wrap') &&
        !active.getAttribute('role')
      ) {
        onNewsletterOpen(dialog);
      }
    }
  }

  function watchNewsletterPopupFocus() {
    document.addEventListener('keydown', trapNewsletterTab, true);
    document.addEventListener(
      'focusin',
      function () {
        var dialog = newsletterDialog();
        if (!newsletterIsOpen(dialog)) return;
        var active = document.activeElement;
        if (
          active &&
          active.matches &&
          active.matches('.mfp-content, .mfp-container') &&
          !active.getAttribute('role')
        ) {
          onNewsletterOpen(dialog);
        }
      },
      true
    );

    var observer = new MutationObserver(function () {
      syncNewsletterFocusState();
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'aria-hidden']
    });
    syncNewsletterFocusState();
  }

  /*
   * WAVE PDP Alert remediation (2026-08-08).
   *
   * The product template can render a rating link for a theme review tab that
   * is not present while the Judge.me app block is the real review region.
   * Point the native link at that existing region, but only when the original
   * fragment is broken.
   */
  function repairPdpReviewTarget(root) {
    var target = document.getElementById('judgeme_product_reviews');
    var links = (root || document).querySelectorAll(
      'a.t4s-product__review[href^="#"]'
    );
    for (var i = 0; i < links.length; i++) {
      var href = links[i].getAttribute('href') || '';
      var id = href.slice(1);
      if (id && document.getElementById(id)) continue;
      if (target) {
        links[i].setAttribute('href', '#judgeme_product_reviews');
        if (links[i].hasAttribute('data-go-id')) {
          links[i].setAttribute('data-go-id', '#judgeme_product_reviews');
        }
        continue;
      }
      var container = links[i].closest(
        '.t4s-product__info-container, [role="dialog"], .mfp-wrap'
      );
      var productLink = container && container.querySelector(
        'a[href*="/products/"]:not(.t4s-product__review)'
      );
      if (productLink) {
        var productHref = (productLink.getAttribute('href') || '').replace(/#.*$/, '');
        links[i].setAttribute('href', productHref + '#judgeme_product_reviews');
        links[i].removeAttribute('data-go-id');
      }
    }
  }

  /*
   * Breadcrumb collection and the adjacent grid/back control are intentionally
   * separate native links, but WAVE sees consecutive identical raw href values.
   * Give the breadcrumb link the useful main-content fragment while preserving
   * both native destinations and the back control's accessible name.
   */
  function disambiguatePdpCollectionLinks(root) {
    var scope = root || document;
    var back = scope.querySelector('.t4s-pr-next-prev a.t4s-nav-back[href]');
    var trail = scope.querySelector('.t4s-pr-breadcrumb');
    if (!back || !trail) return;
    var links = trail.querySelectorAll('a[href]');
    for (var i = links.length - 1; i >= 0; i--) {
      var href = links[i].getAttribute('href') || '';
      if (!href || href !== back.getAttribute('href')) continue;
      links[i].setAttribute('href', href.replace(/#.*$/, '') + '#MainContent');
      break;
    }
  }

  /*
   * Product metafield package contents arrive as hyphen text separated by BRs.
   * Convert only the all-hyphen, two-or-more-line pattern into a semantic list;
   * keep any following packaging note as its own paragraph.
   */
  function normalizePdpPackageLists(root) {
    var spans = (root || document).querySelectorAll(
      'p > span.metafield-multi_line_text_field:not([data-a11y-list-checked])'
    );
    for (var i = 0; i < spans.length; i++) {
      var span = spans[i];
      var parent = span.parentElement;
      if (!parent || parent.tagName !== 'P') continue;
      var rawLines = [];
      var currentLine = '';
      for (var c = 0; c < span.childNodes.length; c++) {
        var contentNode = span.childNodes[c];
        if (contentNode.nodeName === 'BR') {
          rawLines.push(currentLine);
          currentLine = '';
        } else {
          currentLine += contentNode.textContent || '';
        }
      }
      rawLines.push(currentLine);
      var lines = rawLines.map(function (line) {
        return line.replace(/\s+/g, ' ').trim();
      }).filter(Boolean);
      if (lines.length < 2) {
        span.setAttribute('data-a11y-list-checked', '1');
        continue;
      }
      var allItems = true;
      for (var j = 0; j < lines.length; j++) {
        if (!/^[-*]\s+/.test(lines[j])) {
          allItems = false;
          break;
        }
      }
      if (!allItems) {
        span.setAttribute('data-a11y-list-checked', '1');
        continue;
      }

      var noteText = '';
      var seenSpan = false;
      for (var n = 0; n < parent.childNodes.length; n++) {
        var child = parent.childNodes[n];
        if (child === span) {
          seenSpan = true;
          continue;
        }
        if (seenSpan && child.nodeType === Node.TEXT_NODE) {
          noteText += ' ' + (child.nodeValue || '');
        }
      }
      noteText = noteText.replace(/\s+/g, ' ').trim();

      var list = document.createElement('ul');
      list.className = 'a11y-pdp-package-list';
      list.setAttribute('data-a11y-semantic-list', 'product-package');
      for (var k = 0; k < lines.length; k++) {
        var item = document.createElement('li');
        item.textContent = lines[k].replace(/^[-*]\s+/, '');
        list.appendChild(item);
      }
      parent.parentNode.insertBefore(list, parent);
      if (noteText) {
        var note = document.createElement('p');
        note.className = 'a11y-pdp-package-note';
        note.textContent = noteText;
        parent.parentNode.insertBefore(note, parent);
      }
      parent.parentNode.removeChild(parent);
    }
  }

  /*
   * The Judge.me widget already exposes Customer Reviews as level 2. Its
   * individual review titles are level-3 subsections. The separate product
   * question callout is another level-2 section. Keep the numeric 5.0 rating
   * as plain text; it is not a heading despite WAVE's visual heuristic.
   */
  function repairPdpHeadingSemantics(root) {
    var scope = root || document;
    var titles = scope.querySelectorAll(
      '#judgeme_product_reviews .jm-review-content__title'
    );
    for (var i = 0; i < titles.length; i++) {
      titles[i].setAttribute('role', 'heading');
      titles[i].setAttribute('aria-level', '3');
    }
    var questions = scope.querySelectorAll('#b_custom_text_QVt6xg');
    for (var j = 0; j < questions.length; j++) {
      questions[j].setAttribute('role', 'heading');
      questions[j].setAttribute('aria-level', '2');
    }
  }

  function repairPdpWaveAlerts(root) {
    repairPdpReviewTarget(root);
    disambiguatePdpCollectionLinks(root);
    normalizePdpPackageLists(root);
    repairPdpHeadingSemantics(root);
  }

  /*
   * WAVE full-sitemap remediation M6 (2026-08-09).
   * Legacy product cards render the "Show More Colors" affordance as an
   * empty anchor with href="". Give it the product destination and a name;
   * the fragment also keeps it distinct from the adjacent title link.
   */
  function repairEmptyColorMoreLinks(root) {
    var scope = root || document;
    var links = scope.querySelectorAll(
      '.t4s-pr-color__item.is--colors-more a[href=""], ' +
        '.t4s-pr-color__item.is--colors-more a:not([href])'
    );
    for (var i = 0; i < links.length; i++) {
      var link = links[i];
      var card = link.closest(
        '.t4s-product, .t4s-product-wrapper, [data-product-id], article, .t4s-col-item'
      );
      var titleLink = card && card.querySelector(
        '.t4s-product-title a[href], a.t4s-product-title[href], ' +
          '.t4s-product__title a[href], .t4s-widget__pr-title[href]'
      );
      if (!titleLink || !titleLink.href) continue;
      var productName = (titleLink.textContent || '').replace(/\s+/g, ' ').trim();
      var productUrl = titleLink.href.replace(/#.*$/, '');
      link.setAttribute('href', productUrl + '#MainContent');
      link.setAttribute(
        'aria-label',
        productName ? 'View more colors for ' + productName : 'View more colors'
      );
    }
  }

  /* Empty merchant headings have no semantic or visible content. */
  function neutralizeEmptyContentHeadings(root) {
    var scope = root || document;
    var headings = scope.querySelectorAll('main h1, main h2, main h3, main h4, main h5, main h6');
    for (var i = 0; i < headings.length; i++) {
      var heading = headings[i];
      var text = (heading.textContent || '').replace(/\s+/g, ' ').trim();
      var namedImage = heading.querySelector('img[alt]:not([alt=""])');
      if (text || namedImage || heading.getAttribute('aria-label')) continue;
      replaceElementTag(heading, 'div');
    }
  }

  /*
   * Old page/product rich text sometimes starts at H3 directly below the
   * template H1. Preserve copy and attributes while closing skipped levels.
   */
  function normalizeMerchantContentHeadingOrder(root) {
    var scope = root || document;
    var bodies = scope.querySelectorAll(
      '.template-page main .t4s-rte, .template-page main .t4s-page-content, ' +
        'main [id^="t4s-tab-des"]'
    );
    for (var i = 0; i < bodies.length; i++) {
      var previousLevel = 1;
      var headings = bodies[i].querySelectorAll('h2, h3, h4, h5, h6');
      for (var j = 0; j < headings.length; j++) {
        var heading = headings[j];
        var level = parseInt(heading.tagName.slice(1), 10);
        if (level > previousLevel + 1) {
          level = previousLevel + 1;
          heading = replaceElementTag(heading, 'h' + level);
        }
        previousLevel = level;
      }
    }
  }

  function shortProductName(value) {
    var name = (value || '').replace(/\s+/g, ' ').trim().split('|')[0].trim();
    if (name.length > 76) name = name.slice(0, 76).replace(/\s+\S*$/, '').trim();
    return name || 'Product';
  }

  /*
   * The legacy PDP repeats one SEO alt on every main image and thumbnail.
   * Main views receive concise, unique alternatives; thumbnail and hover
   * mirrors are decorative because the adjacent/main image already names the
   * same product.
   */
  function normalizeProductImageAlternatives(root) {
    var scope = root || document;
    var thumbnails = scope.querySelectorAll(
      '.t4s-carousel__nav-inner img[alt], .t4s-carousel__nav-scroller img[alt]'
    );
    for (var i = 0; i < thumbnails.length; i++) {
      thumbnails[i].setAttribute('alt', '');
      thumbnails[i].setAttribute('aria-hidden', 'true');
    }

    var hoverImages = scope.querySelectorAll('.t4s-product-hover-img[alt]');
    for (var h = 0; h < hoverImages.length; h++) {
      hoverImages[h].setAttribute('alt', '');
      hoverImages[h].setAttribute('aria-hidden', 'true');
    }

    var mainImages = scope.querySelectorAll(
      '[data-main-media] img[alt], .t4s-product__media img[alt]'
    );
    var unique = [];
    for (var m = 0; m < mainImages.length; m++) {
      if (mainImages[m].closest('.t4s-carousel__nav-inner, .t4s-carousel__nav-scroller')) continue;
      if (unique.indexOf(mainImages[m]) === -1) unique.push(mainImages[m]);
    }
    if (!unique.length) return;
    var title = scope.querySelector(
      '.t4s-product__info-container h1, h1.t4s-product__title, main h1'
    );
    var productName = shortProductName(title && title.textContent);
    for (var n = 0; n < unique.length; n++) {
      unique[n].setAttribute(
        'alt',
        productName + ' – view ' + (n + 1) + ' of ' + unique.length
      );
      unique[n].removeAttribute('aria-hidden');
    }
  }

  /* Hidden vendor controls still need programmatic names for DOM analyzers. */
  function nameVendorFormControls(root) {
    var scope = root || document;
    var captcha = scope.querySelectorAll(
      'textarea[id^="g-recaptcha-response"], textarea[id^="h-captcha-response"]'
    );
    for (var i = 0; i < captcha.length; i++) {
      if (!captcha[i].getAttribute('aria-label')) {
        captcha[i].setAttribute('aria-label', 'hCaptcha response');
      }
    }
    var variants = scope.querySelectorAll('select.t4s-product__select');
    for (var j = 0; j < variants.length; j++) {
      if (!variants[j].getAttribute('aria-label') && !variants[j].getAttribute('aria-labelledby')) {
        variants[j].setAttribute('aria-label', 'Product variant');
      }
    }
    var reviewSorts = scope.querySelectorAll('#judgeme_product_reviews select');
    for (var k = 0; k < reviewSorts.length; k++) {
      if (!reviewSorts[k].getAttribute('aria-label') && !reviewSorts[k].getAttribute('aria-labelledby')) {
        reviewSorts[k].setAttribute('aria-label', 'Sort reviews');
      }
    }
  }

  /* The parent review-image button already supplies the accessible name. */
  function normalizeJudgeReviewImageAlt(root) {
    var scope = root || document;
    var images = scope.querySelectorAll(
      '#judgeme_product_reviews [role="button"][aria-label] img[alt]'
    );
    for (var i = 0; i < images.length; i++) {
      if (/review image/i.test(images[i].parentElement.getAttribute('aria-label') || '')) {
        images[i].setAttribute('alt', '');
        images[i].setAttribute('aria-hidden', 'true');
      }
    }
  }

  /*
   * Legacy product specifications use an overflow wrapper on mobile. Make the
   * scrollable region keyboard reachable and give it a concise landmark name.
   */
  function makeResponsiveTablesFocusable(root) {
    var scope = root || document;
    var tables = scope.querySelectorAll('.t4s-table-res-df');
    for (var i = 0; i < tables.length; i++) {
      if (!tables[i].hasAttribute('tabindex')) tables[i].setAttribute('tabindex', '0');
      if (!tables[i].getAttribute('role')) tables[i].setAttribute('role', 'region');
      if (!tables[i].getAttribute('aria-labelledby') &&
          (!tables[i].getAttribute('aria-label') ||
           tables[i].getAttribute('data-a11y-responsive-table-label') === '1')) {
        var label = tables.length > 1
          ? 'Product information table ' + (i + 1) + ' of ' + tables.length
          : 'Product information table';
        tables[i].setAttribute('aria-label', label);
        tables[i].setAttribute('data-a11y-responsive-table-label', '1');
      }
    }
  }

  function runAll() {
    try {
      dropDanglingRefs(document);
      syncHiddenSubtrees(document);
      labelSliderHandles(document);
      makeScrollersFocusable(document);
      labelProductGalleries(document);
      labelMiniCartRecommendations(document);
      nameProductCardAtc(document);
      syncProductCardActionButtons(document);
      demotePrivacyOptOutHeadings(document);
      repairHeadingOrder(document);
      normalizePolicyHeadingOrder(document);
      normalizeLongProductImageAlt(document);
      removeRedundantProductTitles(document);
      syncProductSwatchTooltips(document);
      disambiguatePaginationLinks(document);
      disambiguate404FooterHomeLink(document);
      nameSearchCategorySelects(document);
      nameSearchInputs(document);
      enhanceFormPurposes(document);
      decorateDrawerLandmarks();
      hideRedundantCurrencyFlagAlt(document);
      dedupeKnownIds();
      repairAdSemantics(document);
      unlistSliderLists(document);
      syncMenuExpanded();
      syncMobileCurrencyControls();
      repairPdpWaveAlerts(document);
      repairEmptyColorMoreLinks(document);
      neutralizeEmptyContentHeadings(document);
      normalizeMerchantContentHeadingOrder(document);
      normalizeProductImageAlternatives(document);
      nameVendorFormControls(document);
      normalizeJudgeReviewImageAlt(document);
      makeResponsiveTablesFocusable(document);
    } catch (e) {
      /* never break the storefront over an accessibility touch-up */
    }
  }

  function start() {
    runAll();
    /* Let the theme replace its product-card action templates first. */
    scheduleRedundantProductLinks(1200);
    document.addEventListener('keydown', onProductCardActionKeydown, true);
    document.addEventListener('keydown', onMobileCurrencyKeydown, true);
    document.addEventListener('click', onProductCardPointerClick, true);
    document.addEventListener('click', onMobileCurrencyClick, true);
    document.addEventListener('auxclick', onProductCardAuxClick, true);
    try {
      watchCartStatus();
    } catch (e) {
      /* ignore */
    }
    try {
      watchCartErrors();
    } catch (e) {
      /* ignore */
    }
    try {
      watchAtcBusyFocus();
    } catch (e) {
      /* ignore */
    }
    try {
      watchMiniCartFocus();
    } catch (e) {
      /* ignore */
    }
    try {
      watchNewsletterPopupFocus();
    } catch (e) {
      /* ignore */
    }
    try {
      watchHiddenSubtreesImmediately();
    } catch (e) {
      /* ignore */
    }
    var pending = null;
    var observer = new MutationObserver(function () {
      scheduleRedundantProductLinks(600);
      if (pending) return;
      pending = setTimeout(function () {
        pending = null;
        runAll();
      }, 200);
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-hidden', 'class', 'href', 'alt', 'title']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* ========================================================================
 * R4 real-NVDA remediation (2026-08-12)
 * Collection result status and equivalent full-cart table relationships.
 * ======================================================================== */
(function () {
  'use strict';

  if (window.__sigonnaR4NvdaLoaded) return;
  window.__sigonnaR4NvdaLoaded = true;

  function cleanR4(value) {
    return (value || '').replace(/\s+/g, ' ').trim();
  }

  var lastCollectionCountR4 = null;
  var collectionTimerR4 = null;

  function collectionCountR4() {
    var nodes = document.querySelectorAll('.t4s-active-filters__count');
    var fallback = '';
    for (var i = 0; i < nodes.length; i++) {
      var text = cleanR4(nodes[i].textContent);
      if (!text) continue;
      if (!fallback) fallback = text;
      if (typeof nodes[i].getClientRects !== 'function' || nodes[i].getClientRects().length) {
        return text;
      }
    }
    return fallback;
  }

  function ensureCollectionStatusR4() {
    var status = document.getElementById('a11y-collection-status');
    if (status) return status;
    status = document.createElement('div');
    status.id = 'a11y-collection-status';
    status.className = 'a11y-sr-only';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    status.setAttribute('aria-atomic', 'true');
    document.body.appendChild(status);
    return status;
  }

  function syncCollectionStatusR4() {
    var count = collectionCountR4();
    if (!count) return;
    if (lastCollectionCountR4 === null) {
      lastCollectionCountR4 = count;
      if (!/(?:^|[?&])filter\.[^=]+=/.test(window.location.search)) return;
    }
    else {
      if (count === lastCollectionCountR4) return;
      lastCollectionCountR4 = count;
    }
    var status = ensureCollectionStatusR4();
    status.textContent = '';
    setTimeout(function () {
      if (status && document.contains(status)) status.textContent = count;
    }, 40);
  }

  function scheduleCollectionStatusR4() {
    if (collectionTimerR4) clearTimeout(collectionTimerR4);
    collectionTimerR4 = setTimeout(function () {
      collectionTimerR4 = null;
      syncCollectionStatusR4();
    }, 220);
  }

  function cartCellR4(row, text, header) {
    var cell = document.createElement(header ? 'th' : 'td');
    if (header) cell.setAttribute('scope', 'col');
    cell.textContent = text;
    row.appendChild(cell);
  }

  function cartItemDataR4(item) {
    var input = item.querySelector('[data-quantity-value]');
    return {
      product: cleanR4(item.querySelector('.t4s-page_cart__title') &&
        item.querySelector('.t4s-page_cart__title').textContent) || 'Product',
      price: cleanR4(item.querySelector('.t4s-cart_meta_prices_wrap') &&
        item.querySelector('.t4s-cart_meta_prices_wrap').textContent) || 'Not available',
      quantity: cleanR4(input && input.value) || '0',
      total: cleanR4(item.querySelector('.t4s-cart-item-price') &&
        item.querySelector('.t4s-cart-item-price').textContent) || 'Not available'
    };
  }

  function syncCartTableR4() {
    var form = document.querySelector('form[data-cart-content][data-cart-wrapper]');
    if (!form) return;
    var items = form.querySelectorAll('.t4s-page_cart__item[data-cart-item]');
    var existing = form.querySelector('#a11y-cart-items-table');
    if (!items.length) {
      if (existing) existing.parentNode.removeChild(existing);
      return;
    }

    var data = [];
    for (var i = 0; i < items.length; i++) data.push(cartItemDataR4(items[i]));
    var signature = JSON.stringify(data);
    if (existing && existing.getAttribute('data-a11y-cart-signature') === signature) return;

    var table = document.createElement('table');
    table.id = 'a11y-cart-items-table';
    table.className = 'a11y-sr-only';
    table.setAttribute('data-a11y-cart-signature', signature);

    var caption = document.createElement('caption');
    caption.textContent = 'Shopping cart items';
    table.appendChild(caption);

    var head = document.createElement('thead');
    var headRow = document.createElement('tr');
    cartCellR4(headRow, 'Product', true);
    cartCellR4(headRow, 'Price', true);
    cartCellR4(headRow, 'Quantity', true);
    cartCellR4(headRow, 'Total', true);
    head.appendChild(headRow);
    table.appendChild(head);

    var body = document.createElement('tbody');
    for (var j = 0; j < data.length; j++) {
      var row = document.createElement('tr');
      cartCellR4(row, data[j].product, false);
      cartCellR4(row, data[j].price, false);
      cartCellR4(row, data[j].quantity, false);
      cartCellR4(row, data[j].total, false);
      body.appendChild(row);
    }
    table.appendChild(body);

    if (existing) existing.parentNode.replaceChild(table, existing);
    else form.insertBefore(table, form.firstChild);
  }

  function syncDisabledFacetsR4() {
    var links = document.querySelectorAll('.t4s-filter__values li > a');
    for (var i = 0; i < links.length; i++) {
      var item = links[i].closest('li');
      var disabled = !!(item && item.classList.contains('is--disabled'));
      if (disabled) {
        if (!links[i].hasAttribute('data-a11y-facet-tabindex')) {
          links[i].setAttribute(
            'data-a11y-facet-tabindex',
            links[i].hasAttribute('tabindex') ? links[i].getAttribute('tabindex') : ''
          );
        }
        links[i].setAttribute('aria-disabled', 'true');
        links[i].setAttribute('tabindex', '-1');
      } else if (links[i].hasAttribute('data-a11y-facet-tabindex')) {
        var previous = links[i].getAttribute('data-a11y-facet-tabindex');
        if (previous === '') links[i].removeAttribute('tabindex');
        else links[i].setAttribute('tabindex', previous);
        links[i].removeAttribute('aria-disabled');
        links[i].removeAttribute('data-a11y-facet-tabindex');
      }
    }
  }

  function startR4() {
    syncCollectionStatusR4();
    syncCartTableR4();
    syncDisabledFacetsR4();

    var timer = null;
    var observer = new MutationObserver(function () {
      scheduleCollectionStatusR4();
      if (timer) return;
      timer = setTimeout(function () {
        timer = null;
        syncCartTableR4();
        syncDisabledFacetsR4();
      }, 80);
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['value', 'class']
    });
    document.addEventListener('input', function (event) {
      if (event.target && event.target.matches('[data-quantity-value]')) syncCartTableR4();
    }, true);
    document.addEventListener('change', function (event) {
      if (event.target && event.target.matches('[data-quantity-value]')) syncCartTableR4();
    }, true);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startR4);
  else startR4();
})();

/* ========================================================================
 * M10 FAQ disclosure state (2026-08-11).
 * Theme accordion anchors toggle panels but omit control/state relationships.
 * ======================================================================== */
(function () {
  'use strict';

  if (window.__sigonnaM10FaqDisclosureLoaded) return;
  window.__sigonnaM10FaqDisclosureLoaded = true;
  if (!/^\/pages\/faq\/?$/.test(window.location.pathname)) return;

  function faqControls() {
    return document.querySelectorAll('main a[data-t4s-tab-item][href^="#"]');
  }

  function syncFaqDisclosures() {
    var controls = faqControls();
    for (var i = 0; i < controls.length; i++) {
      var control = controls[i];
      var targetId = control.getAttribute('href').slice(1);
      var panel = targetId ? document.getElementById(targetId) : null;
      if (!panel) continue;
      var open = control.parentElement.classList.contains('t4s-active') &&
        window.getComputedStyle(panel).display !== 'none';
      control.setAttribute('role', 'button');
      control.setAttribute('aria-controls', targetId);
      control.setAttribute('aria-expanded', open ? 'true' : 'false');
      panel.setAttribute('aria-hidden', open ? 'false' : 'true');
    }
  }

  function startFaqDisclosures() {
    syncFaqDisclosures();
    document.addEventListener('keydown', function (event) {
      var control = event.target && event.target.closest
        ? event.target.closest('main a[data-t4s-tab-item][role="button"]')
        : null;
      if (!control || event.key !== ' ') return;
      event.preventDefault();
      control.click();
    });
    var timer = null;
    var observer = new MutationObserver(function () {
      if (timer) return;
      timer = setTimeout(function () {
        timer = null;
        syncFaqDisclosures();
      }, 50);
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startFaqDisclosures);
  } else {
    startFaqDisclosures();
  }
})();

/* ========================================================================
 * M11 Assessment residual repair (2026-08-09)
 * Restore focus to the collection Sort disclosure after Escape.
 * ======================================================================== */
(function () {
  'use strict';

  if (window.__sigonnaM11SortFocusLoaded) return;
  window.__sigonnaM11SortFocusLoaded = true;

  var sortOpener = null;
  var restoreAfterEscape = null;

  function openerM11() {
    return document.querySelector(
      'button[data-dropdown-open][data-id="t4s__sortby"], ' +
        'button[data-dropdown-open][aria-controls="t4s__sortby"]'
    );
  }

  function menuM11() {
    return document.getElementById('t4s__sortby');
  }

  function menuOpenM11() {
    var menu = menuM11();
    if (!menu) return false;
    if (!menu.classList.contains('is--opened')) return false;
    var style = window.getComputedStyle(menu);
    var rect = menu.getBoundingClientRect();
    return style.display !== 'none' && style.visibility !== 'hidden' &&
      rect.width > 0 && rect.height > 0;
  }

  function syncM11() {
    var opener = openerM11();
    var menu = menuM11();
    if (!opener || !menu) return;
    if (!menu.id) menu.id = 't4s__sortby';
    /* aria-controls + aria-haspopup makes axe flag this theme-owned popup as
       controlsWithinPopup/incomplete. aria-expanded carries the disclosure
       state without introducing that scanner-visible ambiguity. */
    opener.removeAttribute('aria-controls');
    opener.removeAttribute('aria-haspopup');
    opener.setAttribute('aria-expanded', menuOpenM11() ? 'true' : 'false');
  }

  function rememberM11(event) {
    if (!event.target || !event.target.closest) return;
    var opener = event.target.closest(
      'button[data-dropdown-open][data-id="t4s__sortby"], ' +
        'button[data-dropdown-open][aria-controls="t4s__sortby"]'
    );
    if (opener) sortOpener = opener;
  }

  function restoreM11() {
    var opener = restoreAfterEscape || sortOpener || openerM11();
    restoreAfterEscape = null;
    syncM11();
    if (!opener || menuOpenM11() || !document.contains(opener)) return;
    if (document.activeElement !== opener) {
      try {
        opener.focus({preventScroll: true});
      } catch (error) {
        opener.focus();
      }
    }
  }

  function startM11() {
    syncM11();
    document.addEventListener('click', function (event) {
      rememberM11(event);
      setTimeout(syncM11, 0);
      setTimeout(syncM11, 120);
    }, true);
    document.addEventListener('keydown', function (event) {
      rememberM11(event);
      if (event.key !== 'Escape') return;
      if (!menuOpenM11()) return;
      /* Mobile uses an additional wrapper/close control outside #t4s__sortby;
         any Escape while the sole Sort disclosure is open belongs to it. */
      restoreAfterEscape = sortOpener || openerM11();
      var menu = menuM11();
      var mobileClose = menu && menu.querySelector(
        '.t4s-dropdown__header button[aria-label="Close"]'
      );
      if (mobileClose) {
        var closeRect = mobileClose.getBoundingClientRect();
        if (closeRect.width > 0 && closeRect.height > 0) {
          event.preventDefault();
          mobileClose.click();
          setTimeout(restoreM11, 0);
        }
      }
    }, true);
    document.addEventListener('keyup', function (event) {
      if (event.key !== 'Escape' || !restoreAfterEscape) return;
      setTimeout(restoreM11, 0);
      setTimeout(restoreM11, 80);
    }, false);

    var observer = new MutationObserver(function () {
      setTimeout(syncM11, 0);
    });
    var menu = menuM11();
    if (menu) observer.observe(menu, {
      attributes: true,
      attributeFilter: ['class', 'style', 'aria-hidden']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startM11);
  } else {
    startM11();
  }
})();

/* ========================================================================
 * M9 Accessibility Insights Assessment repairs (2026-08-09)
 * Theme modal containment, carousel semantics, rating alternatives and
 * dynamic header count names. Visual presentation remains unchanged.
 * ======================================================================== */
(function () {
  'use strict';

  if (window.__sigonnaM9AssessmentLoaded) return;
  window.__sigonnaM9AssessmentLoaded = true;

  var quickViewOpenerM9 = null;
  var quickViewWasOpenM9 = false;

  function cleanM9(value) {
    return (value || '').replace(/\s+/g, ' ').trim();
  }

  function focusM9(node) {
    if (!node || typeof node.focus !== 'function') return false;
    try {
      node.focus({preventScroll: true});
    } catch (error) {
      node.focus();
    }
    return document.activeElement === node;
  }

  function visibleFocusableM9(root) {
    if (!root) return [];
    var selector =
      'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), ' +
      'select:not([disabled]), textarea:not([disabled]), iframe, ' +
      '[contenteditable="true"], [tabindex]:not([tabindex="-1"])';
    var nodes = root.querySelectorAll(selector);
    var result = [];
    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      var style = window.getComputedStyle(node);
      var rect = node.getBoundingClientRect();
      if (
        style.display === 'none' ||
        style.visibility === 'hidden' ||
        node.getAttribute('aria-hidden') === 'true' ||
        node.closest('[aria-hidden="true"]') ||
        !rect.width ||
        !rect.height
      ) continue;
      result.push(node);
    }
    return result;
  }

  function searchDialogM9() {
    var dialog = document.getElementById('t4s-search-hidden');
    return dialog && dialog.getAttribute('aria-hidden') === 'false' ? dialog : null;
  }

  function quickViewDialogM9() {
    return document.querySelector(
      '.t4s-modal.t4s-modal--is-active[role="dialog"][aria-hidden="false"]'
    );
  }

  function activeThemeModalM9() {
    return quickViewDialogM9() || searchDialogM9();
  }

  function resolveNewsletterCollisionM9() {
    var dialog = activeThemeModalM9();
    if (!dialog) return;
    var newsletter = document.querySelector(
      '.t4s-newsletter_pp_wrapper.mfp-ready, .t4s-newsletter_pp_wrapper.mfp-open'
    );
    if (!newsletter || newsletter.contains(dialog)) return;
    newsletter.setAttribute('aria-hidden', 'true');
    newsletter.setAttribute('inert', '');
    newsletter.setAttribute('data-a11y-m9-suppressed', '1');
    var close = newsletter.querySelector('.mfp-close');
    if (close && typeof close.click === 'function') close.click();
    var initialControls = visibleFocusableM9(dialog);
    focusM9(initialControls[0] || dialog);
    setTimeout(function () {
      var active = activeThemeModalM9();
      if (!active || active.contains(document.activeElement)) return;
      var controls = visibleFocusableM9(active);
      focusM9(controls[0] || active);
    }, 80);
  }

  function enhanceQuickViewM9(dialog) {
    if (!dialog) return;
    dialog.setAttribute('aria-modal', 'true');
    if (!dialog.getAttribute('aria-label') && !dialog.getAttribute('aria-labelledby')) {
      var title = dialog.querySelector(
        '.t4s-product__title, .t4s-product-title, h1, h2, [data-product-title]'
      );
      var name = cleanM9(title && title.textContent);
      dialog.setAttribute('aria-label', name ? 'Quick view: ' + name : 'Product quick view');
    }
  }

  function trapThemeModalTabM9(event) {
    if (event.key !== 'Tab') return;
    var dialog = activeThemeModalM9();
    if (!dialog) return;
    var controls = visibleFocusableM9(dialog);
    if (!controls.length) {
      event.preventDefault();
      focusM9(dialog);
      return;
    }
    var first = controls[0];
    var last = controls[controls.length - 1];
    var active = document.activeElement;
    if (!dialog.contains(active)) {
      event.preventDefault();
      focusM9(event.shiftKey ? last : first);
    } else if (event.shiftKey && (active === first || active === dialog)) {
      event.preventDefault();
      focusM9(last);
    } else if (!event.shiftKey && active === last) {
      event.preventDefault();
      focusM9(first);
    }
  }

  function containThemeModalFocusM9(event) {
    var dialog = activeThemeModalM9();
    if (!dialog || dialog.contains(event.target)) return;
    resolveNewsletterCollisionM9();
    var controls = visibleFocusableM9(dialog);
    focusM9(controls[0] || dialog);
  }

  function rememberQuickViewOpenerM9(event) {
    var target = event.target && event.target.closest
      ? event.target.closest('[data-action-quickview], [aria-label^="Quick view"]')
      : null;
    if (target && !target.closest('[role="dialog"]')) quickViewOpenerM9 = target;
  }

  function syncQuickViewM9() {
    var dialog = quickViewDialogM9();
    if (dialog) {
      enhanceQuickViewM9(dialog);
      if (!quickViewWasOpenM9) {
        quickViewWasOpenM9 = true;
        setTimeout(function () {
          var open = quickViewDialogM9();
          if (open && !open.contains(document.activeElement)) focusM9(open);
        }, 80);
      }
      return;
    }
    if (!quickViewWasOpenM9) return;
    quickViewWasOpenM9 = false;
    var restore = quickViewOpenerM9;
    quickViewOpenerM9 = null;
    if (
      restore &&
      document.contains(restore) &&
      (!document.activeElement ||
        document.activeElement === document.body ||
        document.activeElement === document.documentElement)
    ) {
      setTimeout(function () {
        if (!quickViewDialogM9()) focusM9(restore);
      }, 50);
    }
  }

  function ratingValueM9(node) {
    var rating = node && node.querySelector('[class*="rating_"]');
    var match = rating && (rating.className || '').match(/(?:^|\s)rating_(\d)(?:_(\d))?(?:\s|$)/);
    if (!match) return '';
    return match[2] ? match[1] + '.' + match[2] : match[1];
  }

  function repairRatingsM9(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var testimonials = scope.querySelectorAll('.t4s-rating-wapper');
    for (var i = 0; i < testimonials.length; i++) {
      var value = ratingValueM9(testimonials[i]);
      if (value) {
        testimonials[i].setAttribute('role', 'img');
        testimonials[i].setAttribute('aria-label', value + ' out of 5 stars');
      }
      var testimonialIcons = testimonials[i].querySelectorAll('svg');
      for (var j = 0; j < testimonialIcons.length; j++) {
        testimonialIcons[j].setAttribute('aria-hidden', 'true');
        testimonialIcons[j].setAttribute('focusable', 'false');
      }
    }

    var productRatings = scope.querySelectorAll('ryviu-widget-total[reviews_data]');
    for (var k = 0; k < productRatings.length; k++) {
      var data = (productRatings[k].getAttribute('reviews_data') || '').split(';');
      var count = parseInt(data[0], 10);
      var score = parseFloat(data[1]);
      var stars = productRatings[k].querySelector('.stars');
      if (!stars) continue;
      if (!isNaN(score) && score > 0) {
        stars.removeAttribute('aria-hidden');
        stars.setAttribute('role', 'img');
        stars.setAttribute('aria-label', score + ' out of 5 stars');
      } else {
        stars.removeAttribute('role');
        stars.removeAttribute('aria-label');
        stars.setAttribute('aria-hidden', 'true');
      }
      var icons = stars.querySelectorAll('svg');
      for (var m = 0; m < icons.length; m++) {
        icons[m].setAttribute('aria-hidden', 'true');
        icons[m].setAttribute('focusable', 'false');
      }
      if (!isNaN(count)) productRatings[k].setAttribute('data-a11y-review-count', String(count));
    }
  }

  function carouselNameM9(carousel, fallback) {
    var section = carousel.closest('section, .shopify-section');
    var heading = section && section.querySelector('h1, h2, h3, [role="heading"]');
    return cleanM9(heading && heading.textContent) || fallback;
  }

  function makeDotKeyboardM9(dot) {
    var label = dot.getAttribute('aria-label') || 'Show testimonial';
    var selected = dot.getAttribute('aria-current') === 'step' ||
      dot.getAttribute('aria-current') === 'page' || dot.classList.contains('is-selected');
    var control = dot.querySelector('button[data-a11y-testimonial-dot-control]');
    if (!control) {
      control = document.createElement('button');
      control.type = 'button';
      control.setAttribute('data-a11y-testimonial-dot-control', '1');
      control.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;' +
        'padding:0;margin:0;border:0;background:transparent;color:inherit;cursor:pointer';
      control.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        dot.click();
      });
      dot.appendChild(control);
    }
    control.setAttribute('aria-label', label);
    if (selected) control.setAttribute('aria-current', 'page');
    else control.removeAttribute('aria-current');
    dot.setAttribute('role', 'none');
    dot.removeAttribute('tabindex');
    dot.removeAttribute('aria-label');
    dot.removeAttribute('aria-current');
    dot.setAttribute('data-a11y-m9-keyboard', '1');
  }

  function repairCarouselsM9(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var heroes = scope.querySelectorAll('.t4s-slideshow[data-flickityt4s-js]');
    for (var i = 0; i < heroes.length; i++) {
      heroes[i].setAttribute('role', 'region');
      heroes[i].setAttribute('aria-roledescription', 'carousel');
      heroes[i].setAttribute('aria-label', carouselNameM9(heroes[i], 'Featured promotions'));
      if (heroes[i].querySelectorAll('.t4s-slideshow-item').length <= 1) {
        heroes[i].removeAttribute('tabindex');
      }
    }

    var testimonials = scope.querySelectorAll('.t4s-testimonials .t4s-flicky-slider');
    for (var j = 0; j < testimonials.length; j++) {
      var carousel = testimonials[j];
      carousel.setAttribute('role', 'region');
      carousel.setAttribute('aria-roledescription', 'carousel');
      carousel.setAttribute('aria-label', carouselNameM9(carousel, 'Customer testimonials'));
      carousel.setAttribute('aria-keyshortcuts', 'ArrowLeft ArrowRight');
      var slides = carousel.querySelectorAll('.t4s-testimonial-item');
      for (var k = 0; k < slides.length; k++) {
        slides[k].setAttribute('role', 'group');
        slides[k].setAttribute('aria-roledescription', 'slide');
        slides[k].setAttribute('aria-label', 'Testimonial ' + (k + 1) + ' of ' + slides.length);
      }
      var dots = carousel.querySelectorAll('.flickityt4s-page-dots .dot, .flickity-page-dots .dot');
      if (dots.length && dots[0].parentElement) {
        dots[0].parentElement.setAttribute('role', 'group');
        dots[0].parentElement.setAttribute('aria-label', 'Choose testimonial');
      }
      for (var m = 0; m < dots.length; m++) {
        dots[m].setAttribute('aria-label', 'Show testimonials ' + (m + 1));
        makeDotKeyboardM9(dots[m]);
      }
    }
  }

  function syncHeaderCountsM9() {
    var definitions = [
      {selector: '[data-count-wishlist]', name: 'Wishlist'},
      {selector: '[data-cart-count]', name: 'Cart'}
    ];
    for (var i = 0; i < definitions.length; i++) {
      var counts = document.querySelectorAll(definitions[i].selector);
      for (var j = 0; j < counts.length; j++) {
        var link = counts[j].closest('a');
        var value = parseInt(cleanM9(counts[j].textContent).replace(/[^\d]/g, ''), 10);
        if (!link || isNaN(value)) continue;
        link.setAttribute(
          'aria-label',
          definitions[i].name + ', ' + value + ' ' + (value === 1 ? 'item' : 'items')
        );
        link.setAttribute('data-a11y-m9-count-name', '1');
      }
    }
  }

  function syncM9(root) {
    enhanceQuickViewM9(quickViewDialogM9());
    syncQuickViewM9();
    resolveNewsletterCollisionM9();
    repairRatingsM9(root || document);
    repairCarouselsM9(root || document);
    syncHeaderCountsM9();
  }

  function startM9() {
    syncM9(document);
    document.addEventListener('click', rememberQuickViewOpenerM9, true);
    document.addEventListener('keydown', function (event) {
      rememberQuickViewOpenerM9(event);
      trapThemeModalTabM9(event);
    }, true);
    document.addEventListener('focusin', containThemeModalFocusM9, true);

    var timer = null;
    var observer = new MutationObserver(function () {
      if (timer) return;
      timer = setTimeout(function () {
        timer = null;
        syncM9(document);
      }, 60);
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['aria-hidden', 'aria-current', 'class']
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startM9);
  else startM9();
})();

/* ========================================================================
 * M8 WAVE optional Alert hardening (2026-08-09)
 * Preserve one native link per destination while pointer-only visual mirrors
 * remain clickable. Collection hero names remain available through the H1.
 * ======================================================================== */
(function () {
  'use strict';

  if (window.__sigonnaM8AlertHardeningLoaded) return;
  window.__sigonnaM8AlertHardeningLoaded = true;

  function cleanM8(value) {
    return (value || '').replace(/\s+/g, ' ').trim();
  }

  function absoluteM8(href) {
    try {
      return new URL(href, document.baseURI).href;
    } catch (error) {
      return href || '';
    }
  }

  function makeM8PointerMirror(anchor, kind) {
    if (!anchor || anchor.hasAttribute('data-a11y-m8-pointer-url')) return;
    var href = anchor.getAttribute('href');
    if (!href) return;
    anchor.setAttribute('data-a11y-m8-pointer-url', absoluteM8(href));
    anchor.setAttribute('data-a11y-m8-kind', kind);
    if (anchor.getAttribute('target')) {
      anchor.setAttribute('data-a11y-m8-target', anchor.getAttribute('target'));
    }
    anchor.removeAttribute('href');
    anchor.removeAttribute('target');
    anchor.removeAttribute('rel');
    anchor.setAttribute('aria-hidden', 'true');
    anchor.setAttribute('tabindex', '-1');
  }

  function normalizeM8RelatedCards(root) {
    var imageLinks = root.querySelectorAll(
      '.t4s-article-related a.t4s-d-block.t4s-eff[href]'
    );
    for (var i = 0; i < imageLinks.length; i++) {
      var imageLink = imageLinks[i];
      var item = imageLink.closest('.t4s-col-item, article, .t4s-article-item');
      var titleLink = item && item.querySelector('.t4s-post-title a[href]');
      if (!titleLink || absoluteM8(titleLink.getAttribute('href')) !== absoluteM8(
        imageLink.getAttribute('href')
      )) continue;
      makeM8PointerMirror(imageLink, 'related-article-image');
    }
  }

  function normalizeM8ArticleNavigation(root) {
    var relatedTargets = {};
    var related = root.querySelectorAll('.t4s-article-related .t4s-post-title a[href]');
    for (var r = 0; r < related.length; r++) {
      relatedTargets[absoluteM8(related[r].getAttribute('href')).replace(/#.*$/, '')] = true;
    }
    var links = root.querySelectorAll('.t4s-article-navigation a[href]');
    for (var i = 0; i < links.length; i++) {
      var link = links[i];
      var url;
      try {
        url = new URL(link.getAttribute('href'), document.baseURI);
      } catch (error) {
        continue;
      }
      if (url.origin !== window.location.origin) continue;
      var isBlogIndex = link.classList.contains('t4s-current-blog');
      var overlapsRelated = !!relatedTargets[url.href.replace(/#.*$/, '')];
      if (!isBlogIndex && !overlapsRelated) continue;
      url.hash = 'MainContent';
      link.setAttribute('href', url.pathname + url.search + url.hash);
      link.setAttribute(
        'data-a11y-m8-kind',
        isBlogIndex ? 'article-blog-main' : 'article-navigation-main'
      );
    }
  }

  function normalizeM8JudgeMedals(root) {
    var widgets = root.querySelectorAll('.jm-medals');
    for (var i = 0; i < widgets.length; i++) {
      var anchors = widgets[i].querySelectorAll('a.jm-medals__medal-link');
      var groups = {};
      for (var j = 0; j < anchors.length; j++) {
        var sourceUrl = anchors[j].getAttribute('href') ||
          anchors[j].getAttribute('data-a11y-m8-pointer-url');
        if (!sourceUrl) continue;
        var key = absoluteM8(sourceUrl);
        if (!groups[key]) groups[key] = [];
        groups[key].push(anchors[j]);
      }
      for (var href in groups) {
        if (!Object.prototype.hasOwnProperty.call(groups, href)) continue;
        var group = groups[href];
        if (group.length < 2) continue;
        var canonical = null;
        for (var c = 0; c < group.length; c++) {
          if (group[c].hasAttribute('href')) {
            canonical = group[c];
            break;
          }
        }
        if (!canonical) continue;
        var names = [];
        for (var k = 0; k < group.length; k++) {
          var title = group[k].querySelector('svg title');
          var name = cleanM8(title && title.textContent);
          if (name && names.indexOf(name) === -1) names.push(name);
        }
        canonical.setAttribute(
          'aria-label',
          names.length ? 'Judge.me verified shop badges: ' + names.join(' and ') :
            'Judge.me verified shop badges: Diamond Authentic Shop and Diamond Transparent Shop'
        );
        canonical.setAttribute('data-a11y-m8-kind', 'judge-medals-canonical');
        for (var m = 0; m < group.length; m++) {
          if (group[m] !== canonical) makeM8PointerMirror(group[m], 'judge-medal-mirror');
        }
      }
    }
  }

  function normalizeM8FooterHome(root) {
    var logos = root.querySelectorAll(
      'footer .t4s-footer-content a.t4s-d-block[href="/"], ' +
        'footer .t4s-footer-content a.t4s-d-block[href="' + window.location.origin + '/"]'
    );
    for (var i = 0; i < logos.length; i++) {
      logos[i].setAttribute('href', '/#MainContent');
      logos[i].setAttribute('data-a11y-m8-kind', 'footer-home-main');
    }
  }

  function normalizeM8CollectionHero(root) {
    var match = window.location.pathname.match(/^\/collections\/(smith|suncloud)\/?$/i);
    if (!match) return;
    var brand = match[1].toLowerCase();
    var images = root.querySelectorAll('main img.t4s-img-as-bg[alt]');
    for (var i = 0; i < images.length; i++) {
      if (cleanM8(images[i].getAttribute('alt')).toLowerCase() !== brand) continue;
      images[i].setAttribute('alt', '');
      images[i].setAttribute('aria-hidden', 'true');
      images[i].setAttribute('data-a11y-m8-kind', 'decorative-collection-hero');
    }
  }

  function followM8PointerMirror(event, mirror) {
    var url = mirror && mirror.getAttribute('data-a11y-m8-pointer-url');
    if (!url) return;
    event.preventDefault();
    event.stopPropagation();
    var newContext = mirror.getAttribute('data-a11y-m8-target') === '_blank' ||
      event.ctrlKey || event.metaKey || event.shiftKey || event.button === 1;
    if (newContext) window.open(url, '_blank', 'noopener');
    else window.location.assign(url);
  }

  function onM8PointerClick(event) {
    var mirror = event.target && event.target.closest
      ? event.target.closest('[data-a11y-m8-pointer-url]')
      : null;
    if (mirror) followM8PointerMirror(event, mirror);
  }

  function onM8AuxClick(event) {
    if (event.button !== 1) return;
    var mirror = event.target && event.target.closest
      ? event.target.closest('[data-a11y-m8-pointer-url]')
      : null;
    if (mirror) followM8PointerMirror(event, mirror);
  }

  function syncM8(root) {
    var scope = root && root.querySelectorAll ? root : document;
    normalizeM8RelatedCards(scope);
    normalizeM8ArticleNavigation(scope);
    normalizeM8JudgeMedals(scope);
    normalizeM8FooterHome(scope);
    normalizeM8CollectionHero(scope);
  }

  function startM8() {
    syncM8(document);
    document.addEventListener('click', onM8PointerClick, true);
    document.addEventListener('auxclick', onM8AuxClick, true);
    var timer = null;
    var observer = new MutationObserver(function () {
      if (timer) return;
      timer = setTimeout(function () {
        timer = null;
        syncM8(document);
      }, 50);
    });
    observer.observe(document.body, {childList: true, subtree: true});
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startM8);
  else startM8();
})();

/* ========================================================================
 * R2 claimant-confirmation repairs (2026-08-04)
 * Menu/search/cart focus, live results, product-context names, mobile footer,
 * contact routes and Judge.me dialog/star semantics.
 * ======================================================================== */
(function () {
  'use strict';

  if (window.__sigonnaR2A11yLoaded) return;
  window.__sigonnaR2A11yLoaded = true;

  var R2_FOCUSABLE =
    'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), ' +
    'select:not([disabled]), textarea:not([disabled]), iframe, ' +
    '[tabindex]:not([tabindex="-1"]), [contenteditable="true"]';

  function cleanText(value) {
    return (value || '').replace(/\s+/g, ' ').trim();
  }

  function focusR2(el) {
    if (!el || typeof el.focus !== 'function') return false;
    try {
      el.focus({ preventScroll: true });
    } catch (e) {
      try {
        el.focus();
      } catch (e2) {
        return false;
      }
    }
    return document.activeElement === el || (el.contains && el.contains(document.activeElement));
  }

  function isR2Visible(el) {
    if (!el || el.disabled) return false;
    if (el.getAttribute('tabindex') === '-1') return false;
    if (el.getAttribute('aria-hidden') === 'true') return false;
    if (el.closest && el.closest('[aria-hidden="true"]')) return false;
    if (typeof el.getClientRects === 'function' && el.getClientRects().length === 0) {
      return false;
    }
    var style = window.getComputedStyle(el);
    return style.display !== 'none' && style.visibility !== 'hidden';
  }

  function r2Focusables(container) {
    if (!container) return [];
    var nodes = container.querySelectorAll(R2_FOCUSABLE);
    var out = [];
    for (var i = 0; i < nodes.length; i++) {
      if (isR2Visible(nodes[i])) out.push(nodes[i]);
    }
    return out;
  }

  function drawerIsOpen(drawer) {
    return !!drawer && drawer.getAttribute('aria-hidden') === 'false';
  }

  function closestFromEvent(event, selector) {
    var target = event && event.target;
    return target && target.closest ? target.closest(selector) : null;
  }

  /* R2-F01: mobile menu focus entry, containment and return. */
  var menuWasOpen = false;
  var menuOpener = null;
  var menuFocusTimers = [];

  function menuDrawerR2() {
    return document.getElementById('t4s-menu-drawer');
  }

  function rememberMenuOpener(event) {
    var opener = closestFromEvent(
      event,
      '[data-menu-drawer][aria-controls="t4s-menu-drawer"], ' +
        '[data-drawer-options*="t4s-menu-drawer"]'
    );
    if (opener) menuOpener = opener;
  }

  function clearMenuTimers() {
    for (var i = 0; i < menuFocusTimers.length; i++) clearTimeout(menuFocusTimers[i]);
    menuFocusTimers = [];
  }

  function focusIntoMenu(drawer) {
    if (!drawerIsOpen(drawer)) return false;
    var nodes = r2Focusables(drawer);
    var target = nodes.length ? nodes[0] : drawer;
    if (!drawer.hasAttribute('tabindex')) drawer.setAttribute('tabindex', '-1');
    return focusR2(target);
  }

  function scheduleMenuFocus(drawer) {
    clearMenuTimers();
    var delays = [0, 80, 200, 450, 800];
    for (var i = 0; i < delays.length; i++) {
      (function (delay) {
        menuFocusTimers.push(
          setTimeout(function () {
            if (!drawerIsOpen(drawer)) return;
            if (!drawer.contains(document.activeElement) || document.activeElement === drawer) {
              focusIntoMenu(drawer);
            }
          }, delay)
        );
      })(delays[i]);
    }
  }

  function restoreMenuFocus() {
    var restore = menuOpener;
    menuOpener = null;
    if (!restore || !document.contains(restore)) {
      restore = document.querySelector(
        '[data-menu-drawer][aria-controls="t4s-menu-drawer"], ' +
          '[data-drawer-options*="t4s-menu-drawer"]'
      );
    }
    if (restore && document.contains(restore)) {
      setTimeout(function () {
        if (!drawerIsOpen(menuDrawerR2())) focusR2(restore);
      }, 60);
    }
  }

  function syncMenuFocusR2() {
    var drawer = menuDrawerR2();
    if (!drawer) return;
    var open = drawerIsOpen(drawer);
    if (open && !menuWasOpen) {
      menuWasOpen = true;
      if (!menuOpener && document.activeElement && !drawer.contains(document.activeElement)) {
        menuOpener = document.activeElement;
      }
      scheduleMenuFocus(drawer);
    } else if (!open && menuWasOpen) {
      menuWasOpen = false;
      clearMenuTimers();
      restoreMenuFocus();
    } else if (open && !drawer.contains(document.activeElement)) {
      scheduleMenuFocus(drawer);
    }
  }

  function trapMenuTab(event) {
    if (event.key !== 'Tab') return;
    var drawer = menuDrawerR2();
    if (!drawerIsOpen(drawer)) return;
    var nodes = r2Focusables(drawer);
    if (!nodes.length) {
      event.preventDefault();
      focusR2(drawer);
      return;
    }
    var first = nodes[0];
    var last = nodes[nodes.length - 1];
    var active = document.activeElement;
    if (!drawer.contains(active)) {
      event.preventDefault();
      focusR2(event.shiftKey ? last : first);
    } else if (event.shiftKey && active === first) {
      event.preventDefault();
      focusR2(last);
    } else if (!event.shiftKey && active === last) {
      event.preventDefault();
      focusR2(first);
    }
  }

  /* R2-F11: mobile collection filter focus entry, containment and return. */
  var filterWasOpen = false;
  var filterOpener = null;
  var filterEscapeOpener = null;
  var filterFocusTimers = [];

  function filterDrawerR2() {
    return document.getElementById('t4s-filter-hidden');
  }

  function rememberFilterOpener(event) {
    var opener = closestFromEvent(
      event,
      '[data-drawer-options*="t4s-filter-hidden"], .t4s-btn-filter[aria-label="Show filters"]'
    );
    if (opener && !opener.closest('#t4s-filter-hidden')) filterOpener = opener;
  }

  function prepareFilterDrawer(drawer) {
    if (!drawer) return;
    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-modal', 'true');
    if (!drawer.getAttribute('aria-label') && !drawer.getAttribute('aria-labelledby')) {
      drawer.setAttribute('aria-label', 'Filter products');
    }
    var close = drawer.querySelector(
      '[data-drawer-close], .t4s-drawer__close, button.t4s-drawer__close'
    );
    if (close) close.setAttribute('aria-label', 'Close filters');
  }

  function clearFilterTimers() {
    for (var i = 0; i < filterFocusTimers.length; i++) clearTimeout(filterFocusTimers[i]);
    filterFocusTimers = [];
  }

  function focusIntoFilter(drawer) {
    if (!drawerIsOpen(drawer)) return false;
    prepareFilterDrawer(drawer);
    var nodes = r2Focusables(drawer);
    var target = nodes.length ? nodes[0] : drawer;
    if (!drawer.hasAttribute('tabindex')) drawer.setAttribute('tabindex', '-1');
    return focusR2(target);
  }

  function scheduleFilterFocus(drawer) {
    clearFilterTimers();
    var delays = [0, 80, 200, 450, 800];
    for (var i = 0; i < delays.length; i++) {
      (function (delay) {
        filterFocusTimers.push(
          setTimeout(function () {
            if (!drawerIsOpen(drawer)) return;
            if (!drawer.contains(document.activeElement) || document.activeElement === drawer) {
              focusIntoFilter(drawer);
            }
          }, delay)
        );
      })(delays[i]);
    }
  }

  function restoreFilterFocus(preferred) {
    var restore = preferred || filterOpener;
    filterOpener = null;
    if (!restore || !document.contains(restore)) {
      restore = document.querySelector(
        '[data-drawer-options*="t4s-filter-hidden"], .t4s-btn-filter[aria-label="Show filters"]'
      );
    }
    if (restore && document.contains(restore)) {
      setTimeout(function () {
        if (!drawerIsOpen(filterDrawerR2())) focusR2(restore);
      }, 60);
    }
  }

  function syncFilterFocusR2() {
    var drawer = filterDrawerR2();
    var open = drawerIsOpen(drawer);
    if (open) prepareFilterDrawer(drawer);
    if (open && !filterWasOpen) {
      filterWasOpen = true;
      if (!filterOpener && document.activeElement && !drawer.contains(document.activeElement)) {
        filterOpener = document.activeElement;
      }
      scheduleFilterFocus(drawer);
    } else if (!open && filterWasOpen) {
      filterWasOpen = false;
      clearFilterTimers();
      restoreFilterFocus();
    } else if (open && !drawer.contains(document.activeElement)) {
      scheduleFilterFocus(drawer);
    }
  }

  function trapFilterTab(event) {
    if (event.key !== 'Tab') return;
    var drawer = filterDrawerR2();
    if (!drawerIsOpen(drawer)) return;
    prepareFilterDrawer(drawer);
    var nodes = r2Focusables(drawer);
    if (!nodes.length) {
      event.preventDefault();
      focusR2(drawer);
      return;
    }
    var first = nodes[0];
    var last = nodes[nodes.length - 1];
    var active = document.activeElement;
    if (!drawer.contains(active)) {
      event.preventDefault();
      focusR2(event.shiftKey ? last : first);
    } else if (event.shiftKey && active === first) {
      event.preventDefault();
      focusR2(last);
    } else if (!event.shiftKey && active === last) {
      event.preventDefault();
      focusR2(first);
    }
  }

  /* R2-F02: search focus return and result status. */
  var searchWasOpen = false;
  var searchOpener = null;
  var searchStatusTimer = null;
  var lastSearchMessage = '';
  var searchResultCandidate = '';
  var searchEscapeOpener = null;

  function searchDrawerR2() {
    return document.getElementById('t4s-search-hidden');
  }

  function rememberSearchOpener(event) {
    var opener = closestFromEvent(
      event,
      '[data-drawer-options*="t4s-search-hidden"], ' +
        'a[href*="/search"][aria-label="Search"]'
    );
    if (opener && !opener.closest('#t4s-search-hidden')) searchOpener = opener;
  }

  function ensureSearchStatus(drawer) {
    if (!drawer) return null;
    var status = drawer.querySelector('#a11y-search-status');
    if (!status) {
      status = document.createElement('div');
      status.id = 'a11y-search-status';
      status.className = 'a11y-sr-only';
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      status.setAttribute('aria-atomic', 'true');
      drawer.appendChild(status);
    }
    return status;
  }

  function setSearchStatus(message) {
    var status = ensureSearchStatus(searchDrawerR2());
    if (!message || !status) return;
    if (message === lastSearchMessage && cleanText(status.textContent) === cleanText(message)) return;
    lastSearchMessage = message;
    status.textContent = '';
    setTimeout(function () {
      if (status && document.contains(status)) status.textContent = message;
    }, 30);
  }

  function searchProductCount(drawer) {
    var results = drawer && drawer.querySelector('[data-results-search]');
    if (!results) return 0;
    var links = results.querySelectorAll('a[href*="/products/"]');
    var seen = {};
    var count = 0;
    for (var i = 0; i < links.length; i++) {
      var href = (links[i].href || links[i].getAttribute('href') || '').split('?')[0];
      if (!href || seen[href]) continue;
      seen[href] = true;
      count++;
    }
    return count;
  }

  function announceSearchResults() {
    var drawer = searchDrawerR2();
    if (!drawerIsOpen(drawer)) return;
    var input = drawer.querySelector('[data-input-search], input[type="search"], input[name="q"]');
    var query = cleanText(input && input.value);
    if (!query) return;
    var count = searchProductCount(drawer);
    var message =
      count + ' search ' + (count === 1 ? 'result' : 'results') + ' available for ' + query + '.';
    var candidate = query + '|' + count;
    if (searchResultCandidate !== candidate) {
      searchResultCandidate = candidate;
      scheduleSearchResults(500);
      return;
    }
    setSearchStatus(message);
  }

  function scheduleSearchResults(delay, replacePending) {
    if (searchStatusTimer) {
      if (!replacePending) return;
      clearTimeout(searchStatusTimer);
    }
    searchStatusTimer = setTimeout(function () {
      searchStatusTimer = null;
      announceSearchResults();
    }, typeof delay === 'number' ? delay : 250);
  }

  function syncSearchFocusR2() {
    var drawer = searchDrawerR2();
    if (!drawer) return;
    ensureSearchStatus(drawer);
    var open = drawerIsOpen(drawer);
    if (open && !searchWasOpen) {
      searchWasOpen = true;
      if (!searchOpener && document.activeElement && !drawer.contains(document.activeElement)) {
        searchOpener = document.activeElement;
      }
      setTimeout(function () {
        if (!drawerIsOpen(drawer)) return;
        var input = drawer.querySelector('[data-input-search], input[type="search"], input[name="q"]');
        if (input && !drawer.contains(document.activeElement)) focusR2(input);
      }, 100);
    } else if (!open && searchWasOpen) {
      searchWasOpen = false;
      lastSearchMessage = '';
      searchResultCandidate = '';
      var restore = searchOpener;
      searchOpener = null;
      if (restore && document.contains(restore)) {
        setTimeout(function () {
          if (!drawerIsOpen(searchDrawerR2()) && document.activeElement !== restore) {
            focusR2(restore);
          }
        }, 60);
      }
    }
  }

  function onSearchInput(event) {
    var drawer = searchDrawerR2();
    if (!drawerIsOpen(drawer) || !drawer.contains(event.target)) return;
    if (!event.target.matches('[data-input-search], input[type="search"], input[name="q"]')) {
      return;
    }
    lastSearchMessage = '';
    searchResultCandidate = '';
    if (cleanText(event.target.value)) setSearchStatus('Searching.');
    // Predictive search can render a broad preliminary set and refine it in a
    // later response. Wait for a quiet result DOM before sampling so that AT
    // hears only the settled count.
    scheduleSearchResults(1200, true);
  }

  /* R2-F05: equivalent complete button semantics for mobile footer accordions. */
  function enhanceFooterAccordions() {
    var openers = document.querySelectorAll('[data-footer-open]');
    var mobile = window.matchMedia && window.matchMedia('(max-width: 767px)').matches;
    for (var i = 0; i < openers.length; i++) {
      var opener = openers[i];
      var parent = opener.parentElement;
      var panel = parent && parent.querySelector(':scope > [data-footer-content]');
      if (!panel) continue;

      if (!opener.id) opener.id = 'a11y-footer-opener-' + (i + 1);
      if (!panel.id) panel.id = 'a11y-footer-panel-' + (i + 1);
      opener.setAttribute('role', 'button');
      opener.setAttribute('tabindex', '0');
      opener.setAttribute('aria-controls', panel.id);

      var open = !!(parent && parent.classList.contains('is--footer_opened'));
      opener.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (mobile) panel.setAttribute('aria-hidden', open ? 'false' : 'true');
      else panel.removeAttribute('aria-hidden');

      if (opener.getAttribute('data-a11y-footer-keyboard') !== '1') {
        opener.setAttribute('data-a11y-footer-keyboard', '1');
        opener.addEventListener('keydown', function (event) {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          event.currentTarget.click();
          setTimeout(enhanceFooterAccordions, 230);
        });
      }
    }
  }

  /* R2-F06: activation destinations must match the visible phone/email labels. */
  function fixMenuContactRoutes() {
    var drawer = menuDrawerR2();
    if (!drawer) return;
    var links = drawer.querySelectorAll('a[href^="tel:"], a[href^="mailto:"]');
    for (var i = 0; i < links.length; i++) {
      var text = cleanText(links[i].textContent).toLowerCase();
      if (text.indexOf('+1-727-477-0901') !== -1) {
        links[i].setAttribute('href', 'tel:+17274770901');
      }
      if (text.indexOf('support@sigonna.com') !== -1) {
        links[i].setAttribute('href', 'mailto:support@sigonna.com');
      }
    }
  }

  /* R2-F04: controls-list/Tab names need product context, even when visible text exists. */
  function productNameForAtc(link) {
    var card =
      link.closest(
        '.t4s-product, .t4s-product-wrapper, [data-product-id], .t4s-pr-grid, ' +
          '.t4s-product-inner, article, li, .t4s-col-item'
      ) || link.parentElement;
    var title = card && card.querySelector(
      '.t4s-product-title, .t4s-product__title, a.t4s-product-title, ' +
        '.t4s-widget__pr-title, [data-product-title], .t4s-pr-name'
    );
    var name = cleanText(title && title.textContent);
    if (!name && link.href) {
      var match = (link.pathname || '').match(/\/products\/([^/?#]+)/);
      if (match) name = decodeURIComponent(match[1]).replace(/-/g, ' ');
    }
    return name;
  }

  function nameProductCardAtcR2(root) {
    var links = (root || document).querySelectorAll('a.t4s-pr-addtocart');
    for (var i = 0; i < links.length; i++) {
      var link = links[i];
      var current = cleanText(link.getAttribute('aria-label'));
      var visible = cleanText(
        (link.querySelector('.t4s-text-pr') && link.querySelector('.t4s-text-pr').textContent) ||
          link.textContent
      );
      var action = current || visible || 'Add to cart';
      var name = productNameForAtc(link);
      if (!name) continue;

      var lowerCurrent = current.toLowerCase();
      var lowerName = name.toLowerCase();
      if (lowerCurrent && lowerCurrent.indexOf(lowerName) !== -1) continue;

      var label;
      if (/add\s+to\s+cart/i.test(action)) label = 'Add ' + name + ' to cart';
      else if (/select|choose|option|style/i.test(action)) label = action + ' for ' + name;
      else label = action + ': ' + name;
      link.setAttribute('aria-label', label);
      link.setAttribute('data-a11y-r2-atc-name', '1');
    }
  }

  /* R2-F07/F09: name the review dialog, expose headings and correct star names. */
  function repairJudgeMeReview(root) {
    var dialogs = (root || document).querySelectorAll(
      '.jdgm-review-widget-modal[role="dialog"], .jdgm-write-review-modal[role="dialog"]'
    );
    for (var i = 0; i < dialogs.length; i++) {
      var dialog = dialogs[i];
      if (!dialog.getAttribute('aria-label') && !dialog.getAttribute('aria-labelledby')) {
        dialog.setAttribute('aria-label', 'Write a product review');
      }
      var titles = dialog.querySelectorAll('.jdgm-write-review-modal__title');
      for (var j = 0; j < titles.length; j++) {
        titles[j].setAttribute('role', 'heading');
        titles[j].setAttribute('aria-level', '2');
      }
      var stars = dialog.querySelectorAll('.jdgm-write-review-modal__stars [data-alt]');
      for (var k = 0; k < stars.length; k++) {
        var score = parseInt(stars[k].getAttribute('data-alt'), 10);
        if (!isNaN(score)) {
          stars[k].setAttribute('aria-label', score + (score === 1 ? ' star' : ' stars'));
        }
      }
    }

    var histogramRows = (root || document).querySelectorAll('.jm-histogram-row');
    for (var h = 0; h < histogramRows.length; h++) {
      var histogramScore = parseInt(
        cleanText(
          histogramRows[h].querySelector('.jm-histogram-row__rating') &&
            histogramRows[h].querySelector('.jm-histogram-row__rating').textContent
        ),
        10
      );
      var histogramStar = histogramRows[h].querySelector('.jm-star-rating[role="img"]');
      if (!isNaN(histogramScore) && histogramStar) {
        histogramStar.setAttribute(
          'aria-label',
          histogramScore + (histogramScore === 1 ? ' star' : ' stars')
        );
      }
    }
  }

  /* R2-F03: preserve cart quantity focus and provide one accurate status. */
  var cartQuantityPending = null;
  var cartQuantityTimers = [];
  var cartQuantityFocusTimers = [];

  function cartInputById(id) {
    var inputs = document.querySelectorAll('[data-quantity-value][data-id]');
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].getAttribute('data-id') === id) return inputs[i];
    }
    return null;
  }

  function cartProductName(input) {
    var label = cleanText(input && input.getAttribute('aria-label'));
    return label.replace(/^quantity\s+for\s+/i, '') || 'Product';
  }

  function clearCartQuantityTimers() {
    for (var i = 0; i < cartQuantityTimers.length; i++) clearTimeout(cartQuantityTimers[i]);
    cartQuantityTimers = [];
  }

  function clearCartQuantityFocusTimers() {
    for (var i = 0; i < cartQuantityFocusTimers.length; i++) {
      clearTimeout(cartQuantityFocusTimers[i]);
    }
    cartQuantityFocusTimers = [];
  }

  function scheduleCartQuantityFocus(id, action) {
    clearCartQuantityFocusTimers();
    var delays = [0, 120, 300, 650, 1100, 1800, 2800];
    for (var i = 0; i < delays.length; i++) {
      (function (delay) {
        cartQuantityFocusTimers.push(
          setTimeout(function () {
            var input = cartInputById(id);
            var wrapper = input && input.closest('[data-quantity-wrapper]');
            var target = input;
            if (wrapper && action === 'increase') {
              target = wrapper.querySelector('[data-increase-qty]') || input;
            }
            if (wrapper && action === 'decrease') {
              target = wrapper.querySelector('[data-decrease-qty]') || input;
            }
            var active = document.activeElement;
            var focusLost =
              !active ||
              active === document.body ||
              active === document.documentElement ||
              !document.contains(active);
            if (focusLost && target && document.contains(target)) focusR2(target);
          }, delay)
        );
      })(delays[i]);
    }
  }

  function announceCartQuantity(message) {
    var region = document.getElementById('a11y-status');
    if (!region) {
      region = document.createElement('div');
      region.id = 'a11y-status';
      region.className = 'a11y-sr-only';
      document.body.appendChild(region);
    }
    region.setAttribute('role', 'status');
    region.setAttribute('aria-live', 'polite');
    region.setAttribute('aria-atomic', 'true');
    region.removeAttribute('tabindex');
    region.textContent = '';
    setTimeout(function () {
      if (region && document.contains(region)) region.textContent = message;
    }, 40);
  }

  function cartCountR2() {
    var cartInputs = document.querySelectorAll(
      '[data-cart-wrapper] [data-quantity-value][data-id], ' +
        '[data-cart-content] [data-quantity-value][data-id]'
    );
    if (cartInputs.length) {
      var total = 0;
      for (var i = 0; i < cartInputs.length; i++) {
        var quantity = parseInt(cartInputs[i].value, 10);
        if (!isNaN(quantity) && quantity > 0) total += quantity;
      }
      return total;
    }
    var node = document.querySelector('[data-cart-count]');
    var count = parseInt(cleanText(node && node.textContent).replace(/[^\d]/g, ''), 10);
    if (!isNaN(count)) return count;
    var match = (document.documentElement.className || '').match(/(?:^|\s)t4s-cart-count-(\d+)/);
    return match ? parseInt(match[1], 10) : 0;
  }

  function finishCartQuantityUpdate() {
    var pending = cartQuantityPending;
    if (!pending) return false;
    var input = cartInputById(pending.id);
    var newQty = input ? parseInt(input.value, 10) : pending.action === 'decrease' ? 0 : NaN;
    if (isNaN(newQty) || newQty === pending.oldQty) return false;

    var wrapper = input && input.closest('[data-quantity-wrapper]');
    var target = input;
    if (wrapper && pending.action === 'increase') target = wrapper.querySelector('[data-increase-qty]') || input;
    if (wrapper && pending.action === 'decrease') target = wrapper.querySelector('[data-decrease-qty]') || input;

    var active = document.activeElement;
    var focusWasLost =
      !active ||
      active === document.body ||
      active === document.documentElement ||
      !document.contains(active) ||
      active === pending.trigger;
    if (focusWasLost && target && document.contains(target)) focusR2(target);

    var count = cartCountR2();
    var itemWord = count === 1 ? 'item' : 'items';
    var message =
      newQty === 0
        ? pending.product + ' removed from cart. Cart contains ' + count + ' ' + itemWord + '.'
        : pending.product +
          ' quantity updated to ' +
          newQty +
          '. Cart contains ' +
          count +
          ' ' +
          itemWord +
          '.';
    announceCartQuantity(message);
    scheduleCartQuantityFocus(pending.id, pending.action);

    cartQuantityPending = null;
    window.__a11yCartQuantityPending = false;
    clearCartQuantityTimers();
    return true;
  }

  function rollbackCartQuantityUpdate(expectedPending) {
    var pending = expectedPending || cartQuantityPending;
    if (!pending || cartQuantityPending !== pending) return false;
    var input = cartInputById(pending.id);
    if (input) {
      input.value = String(pending.oldQty);
      input.setAttribute('data-current-qty', String(pending.oldQty));
    }
    announceCartQuantity(
      pending.product +
        ' quantity remains at ' +
        pending.oldQty +
        ' because the cart could not be updated.'
    );
    scheduleCartQuantityFocus(pending.id, pending.action);
    cartQuantityPending = null;
    window.__a11yCartQuantityPending = false;
    clearCartQuantityTimers();
    return true;
  }

  function isCartChangeRequest(input) {
    var url = '';
    if (typeof input === 'string') url = input;
    else if (input && typeof input.url === 'string') url = input.url;
    return /\/cart\/change(?:\.js)?(?:[?#]|$)/.test(url);
  }

  function installCartFailureRollback() {
    if (!window.fetch || window.fetch.__sigonnaR3CartRollback) return;
    var nativeFetch = window.fetch;
    var wrappedFetch = function () {
      var args = arguments;
      var requestPending = isCartChangeRequest(args[0]) ? cartQuantityPending : null;
      return nativeFetch.apply(this, args).then(
        function (response) {
          if (!requestPending) return response;
          if (!response.ok) {
            rollbackCartQuantityUpdate(requestPending);
          } else if (response.clone) {
            response
              .clone()
              .json()
              .then(function (payload) {
                if (payload && payload.status) rollbackCartQuantityUpdate(requestPending);
              })
              .catch(function () {
                /* A non-JSON success response is handled by the theme. */
              });
          }
          return response;
        },
        function (error) {
          if (requestPending) rollbackCartQuantityUpdate(requestPending);
          throw error;
        }
      );
    };
    wrappedFetch.__sigonnaR3CartRollback = true;
    wrappedFetch.__sigonnaNativeFetch = nativeFetch;
    window.fetch = wrappedFetch;
  }

  function installCartUpdatedConfirmation() {
    var jq = window.jQuery_T4NT || window.jQuery;
    if (!jq || !jq.fn) return;
    jq(window)
      .off('cart:updated.a11yR3')
      .on('cart:updated.a11yR3', function (event, status) {
        if (!cartQuantityPending) return;
        if (status === 'error') rollbackCartQuantityUpdate(cartQuantityPending);
        else finishCartQuantityUpdate();
      });
  }

  function scheduleCartQuantityFinish() {
    clearCartQuantityTimers();
    /* Success is finalized only by the theme's cart:updated confirmation.
       This timeout merely releases a stale guard if a third-party script
       aborts without emitting either success or failure. */
    cartQuantityTimers.push(
      setTimeout(function () {
        if (!cartQuantityPending) return;
        cartQuantityPending = null;
        window.__a11yCartQuantityPending = false;
      }, 7000)
    );
  }

  function rememberCartQuantity(event) {
    var control = closestFromEvent(
      event,
      '[data-increase-qty], [data-decrease-qty], [data-quantity-value]'
    );
    if (!control || !control.closest('[data-cart-wrapper], [data-cart-content]')) return;
    var wrapper = control.closest('[data-quantity-wrapper]');
    var input =
      (control.matches('[data-quantity-value]') && control) ||
      (wrapper && wrapper.querySelector('[data-quantity-value]'));
    if (!input || !input.getAttribute('data-id')) return;
    var oldQty = parseInt(input.getAttribute('data-current-qty') || input.value, 10);
    if (isNaN(oldQty)) return;
    var action = control.hasAttribute('data-decrease-qty')
      ? 'decrease'
      : control.hasAttribute('data-increase-qty')
        ? 'increase'
        : 'input';
    cartQuantityPending = {
      id: input.getAttribute('data-id'),
      oldQty: oldQty,
      action: action,
      product: cartProductName(input),
      trigger: control
    };
    clearCartQuantityFocusTimers();
    window.__a11yCartQuantityPending = true;
    window.__a11yCartQuantitySuppressUntil = Date.now() + 5000;
    scheduleCartQuantityFinish();
  }

  function syncR2() {
    syncMenuFocusR2();
    syncFilterFocusR2();
    syncSearchFocusR2();
    enhanceFooterAccordions();
    fixMenuContactRoutes();
    nameProductCardAtcR2(document);
    repairJudgeMeReview(document);
  }

  function startR2() {
    installCartFailureRollback();
    installCartUpdatedConfirmation();
    syncR2();

    document.addEventListener('click', function (event) {
      rememberMenuOpener(event);
      rememberFilterOpener(event);
      rememberSearchOpener(event);
      rememberCartQuantity(event);
    }, true);
    document.addEventListener('keydown', function (event) {
      rememberMenuOpener(event);
      rememberFilterOpener(event);
      rememberSearchOpener(event);
      if (event.key === 'Enter' || event.key === ' ') rememberCartQuantity(event);
      trapMenuTab(event);
      trapFilterTab(event);
      if (event.key === 'Escape') {
        var closingMenu = menuDrawerR2();
        if (drawerIsOpen(closingMenu)) {
          var closingMenuOpener =
            menuOpener ||
            document.querySelector(
              '[data-menu-drawer][aria-controls="t4s-menu-drawer"], ' +
                '[data-drawer-options*="t4s-menu-drawer"]'
            );
          if (closingMenuOpener) closingMenuOpener.setAttribute('aria-expanded', 'false');
        }
        var closingFilter = filterDrawerR2();
        if (drawerIsOpen(closingFilter)) filterEscapeOpener = filterOpener;
        var closingSearch = searchDrawerR2();
        if (drawerIsOpen(closingSearch)) searchEscapeOpener = searchOpener;
        setTimeout(syncR2, 80);
        setTimeout(syncR2, 220);
      }
    }, true);
    document.addEventListener('keyup', function (event) {
      if (event.key !== 'Escape') return;
      // The theme closes drawers on keyup from a body listener. This document
      // listener runs later in the same bubble path, before AT reports the
      // browser's temporary fallback focus.
      if (searchEscapeOpener) {
        var searchRestore = searchEscapeOpener;
        searchEscapeOpener = null;
        if (
          !drawerIsOpen(searchDrawerR2()) &&
          document.contains(searchRestore) &&
          document.activeElement !== searchRestore
        ) {
          focusR2(searchRestore);
        }
      }
      if (filterEscapeOpener) {
        var filterRestore = filterEscapeOpener;
        filterEscapeOpener = null;
        if (
          !drawerIsOpen(filterDrawerR2()) &&
          document.contains(filterRestore) &&
          document.activeElement !== filterRestore
        ) {
          focusR2(filterRestore);
        }
      }
    }, false);
    document.addEventListener('change', rememberCartQuantity, true);
    document.addEventListener('input', onSearchInput, true);

    if (window.matchMedia) {
      var footerMedia = window.matchMedia('(max-width: 767px)');
      if (footerMedia.addEventListener) footerMedia.addEventListener('change', enhanceFooterAccordions);
      else if (footerMedia.addListener) footerMedia.addListener(enhanceFooterAccordions);
    }

    var pending = null;
    var observer = new MutationObserver(function (records) {
      var searchChanged = false;
      var cartChanged = false;
      for (var i = 0; i < records.length; i++) {
        var target = records[i].target;
        if (target && target.nodeType === 3) target = target.parentElement;
        if (target && target.closest && target.closest('#t4s-search-hidden [data-results-search]')) {
          searchChanged = true;
        }
        if (target && target.closest && target.closest('[data-cart-wrapper], [data-cart-content]')) {
          cartChanged = true;
        }
      }
      if (searchChanged) scheduleSearchResults(1200);
      if (cartChanged && cartQuantityPending) scheduleCartQuantityFocus(
        cartQuantityPending.id,
        cartQuantityPending.action
      );
      if (pending) return;
      pending = setTimeout(function () {
        pending = null;
        syncR2();
      }, 70);
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['aria-hidden', 'class']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startR2);
  } else {
    startR2();
  }
})();

/* ========================================================================
 * R3 claimant-risk repairs (2026-08-05)
 * Variant choice, price units, optional contact phone and dormant controls.
 * ======================================================================== */
(function () {
  'use strict';

  if (window.__sigonnaR3A11yLoaded) return;
  window.__sigonnaR3A11yLoaded = true;

  function cleanR3(value) {
    return (value || '').replace(/\s+/g, ' ').trim();
  }

  /* HTML does not permit role=radio on a <label>.  The theme's swatch handler
   * is delegated to [data-swatch-item], so promote the visual label to a real
   * type=button before applying radio semantics.  Keep the hidden native input
   * as the form value/source of truth and remember its id on the button. */
  function variantControl(label) {
    if (!label || label.tagName !== 'LABEL') return label;
    var button = document.createElement('button');
    for (var i = 0; i < label.attributes.length; i++) {
      var attribute = label.attributes[i];
      if (attribute.name === 'for' || attribute.name === 'role' ||
          attribute.name === 'aria-checked' || attribute.name === 'aria-disabled' ||
          attribute.name === 'tabindex') continue;
      button.setAttribute(attribute.name, attribute.value);
    }
    button.type = 'button';
    button.setAttribute('data-a11y-variant-input', label.getAttribute('for'));
    while (label.firstChild) button.appendChild(label.firstChild);
    label.parentNode.replaceChild(button, label);
    return button;
  }

  function variantLabels(group) {
    if (!group) return [];
    var nodes = Array.prototype.slice.call(group.querySelectorAll(
      'label[data-swatch-item][for], button[data-swatch-item][data-a11y-variant-input]'
    ));
    for (var i = 0; i < nodes.length; i++) nodes[i] = variantControl(nodes[i]);
    return nodes;
  }

  function variantInput(label) {
    var id = label.getAttribute('data-a11y-variant-input') || label.getAttribute('for');
    return id ? document.getElementById(id) : null;
  }

  function isVariantUnavailable(label) {
    return label.classList.contains('is--unavailable') || label.classList.contains('is--soldout');
  }

  function syncVariantGroup(group, index) {
    var labels = variantLabels(group);
    if (!labels.length) return;
    var title = group.querySelector('.t4s-swatch__title');
    var name = cleanR3(title && title.textContent).split(':')[0] || 'Product option';
    if (!group.id) group.id = 'a11y-variant-group-' + index;
    group.setAttribute('role', 'radiogroup');
    group.setAttribute('aria-label', name);

    var selected = null;
    for (var i = 0; i < labels.length; i++) {
      if (labels[i].classList.contains('is--selected')) {
        selected = labels[i];
        break;
      }
    }
    if (!selected) {
      for (var j = 0; j < labels.length; j++) {
        var candidateInput = variantInput(labels[j]);
        if (candidateInput && candidateInput.checked) {
          selected = labels[j];
          break;
        }
      }
    }

    var entry = selected;
    if (!entry || isVariantUnavailable(entry)) {
      for (var k = 0; k < labels.length; k++) {
        if (!isVariantUnavailable(labels[k])) {
          entry = labels[k];
          break;
        }
      }
    }
    if (!entry) entry = selected || labels[0];

    for (var n = 0; n < labels.length; n++) {
      var label = labels[n];
      var checked = label === selected;
      var unavailable = isVariantUnavailable(label);
      var input = variantInput(label);
      label.setAttribute('role', 'radio');
      label.setAttribute('aria-checked', checked ? 'true' : 'false');
      label.setAttribute('aria-disabled', unavailable ? 'true' : 'false');
      label.setAttribute('tabindex', label === entry ? '0' : '-1');
      if (input && input.type === 'radio') {
        /* The visual <label> is now a real button, so it no longer supplies a
         * native label for the hidden form radio.  Keep that source-of-truth
         * input explicitly named for static analyzers and any integration that
         * temporarily exposes it. */
        if (!input.getAttribute('aria-label') && !input.getAttribute('aria-labelledby')) {
          var inputName = cleanR3(
            label.getAttribute('aria-label') || label.textContent || input.value
          );
          input.setAttribute('aria-label', inputName || name + ' option');
        }
        input.checked = checked;
      }
    }
  }

  function syncVariantGroups() {
    var groups = document.querySelectorAll('[data-swatch-option]');
    for (var i = 0; i < groups.length; i++) syncVariantGroup(groups[i], i + 1);
  }

  function moveVariantSelection(event, label) {
    var group = label.closest('[data-swatch-option]');
    var labels = variantLabels(group);
    var current = labels.indexOf(label);
    var target = null;
    var direction = event.key === 'ArrowLeft' || event.key === 'ArrowUp' ? -1 : 1;
    if (event.key === 'Home') {
      direction = 1;
      current = -1;
    } else if (event.key === 'End') {
      direction = -1;
      current = labels.length;
    }
    for (var step = 1; step <= labels.length; step++) {
      var next = (current + direction * step + labels.length) % labels.length;
      if (labels[next].getAttribute('aria-disabled') !== 'true') {
        target = labels[next];
        break;
      }
    }
    if (!target) return;
    event.preventDefault();
    target.click();
    setTimeout(function () {
      syncVariantGroup(group, 1);
      target.focus();
    }, 0);
    setTimeout(function () {
      syncVariantGroup(group, 1);
      target.focus();
    }, 100);
  }

  function onVariantKeydown(event) {
    var label = event.target && event.target.closest
      ? event.target.closest('[data-swatch-item][role="radio"]')
      : null;
    if (!label) return;
    if (event.key === 'ArrowLeft' || event.key === 'ArrowRight' ||
        event.key === 'ArrowUp' || event.key === 'ArrowDown' ||
        event.key === 'Home' || event.key === 'End') {
      moveVariantSelection(event, label);
      return;
    }
    if (event.key !== ' ' && event.key !== 'Enter') return;
    event.preventDefault();
    if (label.getAttribute('aria-disabled') === 'true') return;
    label.click();
    setTimeout(syncVariantGroups, 0);
    setTimeout(syncVariantGroups, 100);
  }

  function formatDollarValue(raw) {
    var cents = Number(raw);
    if (!isFinite(cents)) return '';
    try {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(cents / 100);
    } catch (error) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function syncPriceSliderValues() {
    var handles = document.querySelectorAll('.noUi-handle[role="slider"][aria-valuenow]');
    for (var i = 0; i < handles.length; i++) {
      var text = formatDollarValue(handles[i].getAttribute('aria-valuenow'));
      if (text && handles[i].getAttribute('aria-valuetext') !== text) {
        handles[i].setAttribute('aria-valuetext', text);
      }
    }
  }

  function makeContactPhoneOptional() {
    if (!/^\/pages\/contact\/?$/.test(window.location.pathname)) return;
    var inputs = document.querySelectorAll('#contact_form_page-phone, input[name="contact[phone]"]');
    for (var i = 0; i < inputs.length; i++) {
      inputs[i].removeAttribute('required');
      inputs[i].removeAttribute('aria-required');
      inputs[i].removeAttribute('data-field-required');
    }
  }

  function setDormantControl(control, dormant) {
    if (!control) return;
    if (dormant) {
      if (!control.hasAttribute('data-a11y-r3-dormant')) {
        control.setAttribute('data-a11y-r3-tabindex', control.hasAttribute('tabindex') ? control.getAttribute('tabindex') : '');
      }
      control.setAttribute('data-a11y-r3-dormant', '1');
      control.disabled = true;
      control.setAttribute('aria-hidden', 'true');
      control.setAttribute('tabindex', '-1');
      return;
    }
    if (!control.hasAttribute('data-a11y-r3-dormant')) return;
    control.removeAttribute('data-a11y-r3-dormant');
    control.disabled = false;
    control.removeAttribute('aria-hidden');
    var oldTabindex = control.getAttribute('data-a11y-r3-tabindex');
    control.removeAttribute('data-a11y-r3-tabindex');
    if (oldTabindex === '') control.removeAttribute('tabindex');
    else control.setAttribute('tabindex', oldTabindex);
  }

  function syncDormantControls() {
    var nav = document.querySelectorAll('button.btn_pnav_prev, button.btn_pnav_next');
    for (var i = 0; i < nav.length; i++) {
      var inactive = nav[i].classList.contains('t4s-pe-none') || nav[i].classList.contains('t4s-op-0');
      setDormantControl(nav[i], inactive);
    }
    var closes = document.querySelectorAll('button.t4s-drawer-menu__close');
    for (var j = 0; j < closes.length; j++) {
      var drawer = closes[j].previousElementSibling;
      var open = !!drawer && drawer.getAttribute('aria-hidden') === 'false';
      setDormantControl(closes[j], !open);
    }
  }

  function syncR3() {
    syncVariantGroups();
    syncPriceSliderValues();
    makeContactPhoneOptional();
    syncDormantControls();
  }

  function startR3() {
    syncR3();
    document.addEventListener('keydown', onVariantKeydown, true);
    document.addEventListener('click', function (event) {
      if (!event.target || !event.target.closest || !event.target.closest('[data-swatch-item]')) return;
      setTimeout(syncVariantGroups, 0);
      setTimeout(syncVariantGroups, 120);
    }, false);

    var timer = null;
    var observer = new MutationObserver(function () {
      if (timer) return;
      timer = setTimeout(function () {
        timer = null;
        syncR3();
      }, 40);
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'aria-hidden', 'aria-valuenow', 'checked']
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startR3);
  else startR3();
})();

/* ========================================================================
 * M7 WAVE Alert semantic repairs (2026-08-09)
 * Heading hierarchy and one content list; visible copy remains unchanged.
 * ======================================================================== */
(function () {
  'use strict';

  if (window.__sigonnaM7AlertSemanticsLoaded) return;
  window.__sigonnaM7AlertSemanticsLoaded = true;

  function cleanM7(value) {
    return (value || '').replace(/\s+/g, ' ').trim();
  }

  function replaceM7Tag(node, tagName) {
    if (!node || node.tagName.toLowerCase() === tagName.toLowerCase()) return node;
    var presentation = window.getComputedStyle(node);
    var fontSize = presentation.fontSize;
    var lineHeight = presentation.lineHeight;
    var replacement = document.createElement(tagName);
    for (var i = 0; i < node.attributes.length; i++) {
      replacement.setAttribute(node.attributes[i].name, node.attributes[i].value);
    }
    replacement.style.fontSize = fontSize;
    replacement.style.lineHeight = lineHeight;
    while (node.firstChild) replacement.appendChild(node.firstChild);
    node.parentNode.replaceChild(replacement, node);
    return replacement;
  }

  function normalizeM7ProductHeadings(root) {
    var fitGuide = root.querySelectorAll('h3.sr-fit-guide-title');
    for (var i = 0; i < fitGuide.length; i++) replaceM7Tag(fitGuide[i], 'h2');

    var swatchTitles = root.querySelectorAll('h4.t4s-swatch__title');
    for (var j = 0; j < swatchTitles.length; j++) replaceM7Tag(swatchTitles[j], 'p');
  }

  function normalizeM7DeliveryHeadings(root) {
    if (!/^\/pages\/delivery-return\/?$/.test(window.location.pathname)) return;
    var headings = root.querySelectorAll('main h1');
    for (var i = 0; i < headings.length; i++) {
      var text = cleanM7(headings[i].textContent);
      if (/^(?:1\.\s*Shipping Policy|2\.\s*Return & Refund Policy)$/i.test(text)) {
        replaceM7Tag(headings[i], 'h2');
      }
    }
  }

  function normalizeM7WishlistHeading(root) {
    if (!/^\/search\/?$/.test(window.location.pathname) ||
        new URLSearchParams(window.location.search).get('view') !== 'wishlist') return;
    var empty = root.querySelector('h4.t4s_empty_wishlist__heading');
    if (empty) replaceM7Tag(empty, 'h2');
  }

  function normalizeM7DuplicateArticleTitle(root) {
    if (!/^\/blogs\/[^/]+\/[^/]+\/?$/.test(window.location.pathname)) return;
    var headings = root.querySelectorAll('main h1');
    if (headings.length < 2) return;
    var primaryText = cleanM7(headings[0].textContent);
    for (var i = 1; i < headings.length; i++) {
      if (headings[i].closest('article') && cleanM7(headings[i].textContent) === primaryText) {
        replaceM7Tag(headings[i], 'h2');
      }
    }
  }

  function copyM7ParagraphPresentation(paragraph, item) {
    var style = window.getComputedStyle(paragraph);
    item.style.display = 'block';
    item.style.marginTop = style.marginTop;
    item.style.marginRight = style.marginRight;
    item.style.marginBottom = style.marginBottom;
    item.style.marginLeft = style.marginLeft;
    item.style.paddingTop = style.paddingTop;
    item.style.paddingRight = style.paddingRight;
    item.style.paddingBottom = style.paddingBottom;
    item.style.paddingLeft = style.paddingLeft;
    item.style.color = style.color;
    item.style.font = style.font;
    item.style.letterSpacing = style.letterSpacing;
    item.style.lineHeight = style.lineHeight;
    item.style.textAlign = style.textAlign;
  }

  function normalizeM7ArticleList(root) {
    if (!/^\/blogs\/news\/how-can-i-protect-my-eyeglasses\/?$/.test(
      window.location.pathname
    )) return;
    if (document.querySelector('[data-a11y-semantic-list="eyeglass-care"]')) return;

    var expected = [
      /^-\s*Keep them clean\b/i,
      /^-\s*Store them properly\b/i,
      /^-\s*Handle them with care\b/i
    ];
    var paragraphs = root.querySelectorAll('main p');
    var matches = [];
    for (var i = 0; i < expected.length; i++) {
      var match = null;
      for (var j = 0; j < paragraphs.length; j++) {
        if (expected[i].test(cleanM7(paragraphs[j].textContent))) {
          match = paragraphs[j];
          break;
        }
      }
      if (!match) return;
      matches.push(match);
    }
    if (matches[0].parentNode !== matches[1].parentNode ||
        matches[0].parentNode !== matches[2].parentNode) return;
    if (!(matches[0].compareDocumentPosition(matches[1]) & Node.DOCUMENT_POSITION_FOLLOWING) ||
        !(matches[1].compareDocumentPosition(matches[2]) & Node.DOCUMENT_POSITION_FOLLOWING)) {
      return;
    }

    var list = document.createElement('ul');
    list.setAttribute('data-a11y-semantic-list', 'eyeglass-care');
    list.style.listStyle = 'none';
    list.style.margin = '0';
    list.style.padding = '0';
    matches[0].parentNode.insertBefore(list, matches[0]);
    for (var k = 0; k < matches.length; k++) {
      var item = document.createElement('li');
      item.setAttribute('data-a11y-source', 'care-paragraph');
      copyM7ParagraphPresentation(matches[k], item);
      while (matches[k].firstChild) item.appendChild(matches[k].firstChild);
      list.appendChild(item);
      matches[k].parentNode.removeChild(matches[k]);
    }
  }

  function syncM7(root) {
    var scope = root && root.querySelectorAll ? root : document;
    normalizeM7ProductHeadings(scope);
    normalizeM7DeliveryHeadings(scope);
    normalizeM7WishlistHeading(scope);
    normalizeM7DuplicateArticleTitle(scope);
    normalizeM7ArticleList(scope);
  }

  function startM7() {
    syncM7(document);
    var timer = null;
    var observer = new MutationObserver(function () {
      if (timer) return;
      timer = setTimeout(function () {
        timer = null;
        syncM7(document);
      }, 50);
    });
    observer.observe(document.body, {childList: true, subtree: true});
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startM7);
  else startM7();
})();
